import { InterestType, NoteTypes } from './translationType';
const nnTranslations = {
    unavailableAccountsTitle: 'Kontoar som ikkje er tilgjengelege',
    pushPopup: {
        title: 'Nyheit! Pushvarslingar er her!',
        description: 'Ynskjer du å halda deg oppdatert på endringar og ting du må ta stilling til i mobilbanken, kan du no skru på pushvarslingar og få meir kontroll på økonomien i det daglege.',
        buttonText: 'Gå til Pushvarslingar',
        notNow: 'Ikkje no',
    },
    loans: {
        extraDownpayment: 'Ekstra innbetaling',
        infoTextDownPayment: 'Ved ekstra innbetaling på lån vil løpetida reduserast, du kan sjå ny løpetid i nedbetalingsplanen.',
        seeOurLoans: 'Sjå kva slags lån du kan få',
    },
    newLoan: {
        title: 'Treng du lån?',
        description: 'Vel mellom fleire typar lån og sjekk kor mykje du kan låna',
    },
    closeAccount: {
        nextButton: 'Neste',
        cannotDelete: 'Denne kontoen kan dessverre ikkje bli sletta her',
        chooseAccount: 'Vel ein konto',
        previousButton: 'Førre',
        confirmTitle: 'Er du sikker på at du vil avslutte kontoen?',
        confirmText: 'Kontoen vil bli sletta og du vil ikkje få tilgang til den igjen. Saldo og opptjente renter vil bli overført til mottakarkonto ved neste bankverkedag.',
        confirmButton: 'Avslutt konto',
        doneButton: 'OK',
        success: 'Kontoen vart sletta!',
        title: 'Avslutt konto',
        transferTo: 'Kor ynskjer du at saldo og opptente renter skal overførast?',
        contactUs: 'Kontakt oss dersom du vil ha hjelp med dette.',
        contactUsButton: 'Kontakt oss',
        closeRecurringPayment: 'Vi kan ikkje avslutte kontoen',
        closeRecurringPaymentDescription: 'Du har faste betalingsavtalar på denne kontoen, og kan derfor ikkje avslutte den. Trykk på knappen under for å endre faste betalingsavtalar.',
        closeRecurringPaymentLink: 'Til faste betalingsavtalar',
        closeCardTitle: 'Du må sperra kort først',
        closeCardText: 'Du har {} knytt til denne kontoen som må sperrast permanent, før du kan avslutta kontoen din.',
        closeCardDescription: 'Merk at du sjølv må gå inn og sperra permanent det kortet du ikkje vel no. Når alt er sperra kan du starta avslutningsprosessen av kontoen på nytt.',
        card: 'kort',
        cancel: 'Avbryt',
        cardOwnerSuffix: 'sitt kort',
    },
    aboutApp: {
        version: 'Appversjon {}',
        thirdPartyLicenses: 'Tredjepartslisensar',
        privacy: 'Personvern',
    },
    accountNotFound: {
        noAccount: 'Vi beklagar, denne kontoen finst ikkje.',
        toFrontPage: 'Til framsida',
    },
    approvalItem: {
        overdue: 'Har forfalle',
        overdueToday: 'Frist i dag!',
        deadline: 'Frist',
        sharedBy: 'Delt av {}',
    },
    add: 'Legg til',
    kidRequiredError: 'Denne mottakaren krev KID-nummer. Dette blir ikkje enno støtta.',
    paymentInfoMessages: {
        TRANSFER: {
            success: 'Overføringa vart fullført',
            successPlural: 'Overføringane vart fullført',
            successFuture: 'Overføringa vart lagt til forfall',
            error: {
                heading: 'Uff då!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om overføringa vart fullført før du prøver om att.',
                check: 'Sjekk transaksjonar',
                checkFuturePayments: 'Sjekk komande betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Overføringa vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat overføring',
                description: 'Du la til ei overføring på same beløp til denne kontoen tidlegare i dag',
                continue: 'Gå til signering',
                change: 'Endre betalinga',
            },
        },
        PAYMENT: {
            success: 'Betalinga vart fullført',
            successPlural: 'Betalingane vart fullført',
            successFuture: 'Betalinga vart lagt til forfall',
            error: {
                heading: 'Betalinga vart ikkje fullført',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om betalinga vart fullført før du prøver om att.',
                check: 'Sjekk transaksjonar',
                checkFuturePayments: 'Sjekk komande betalingar',
            },
            notSigned: {
                heading: 'Betalinga vart ikkje fullført',
                description: 'Betalinga vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat betaling',
                description: 'Du la til ei betaling på same beløp til denne kontoen tidlegare i dag',
                continue: 'Gå til signering',
                change: 'Endre betalinga',
            },
        },
        EFAKTURA: {
            success: 'eFaktura vart godkjent',
            successPlural: 'Betalingane vart fullført',
            successFuture: 'Betalinga vart lagt til forfall',
            error: {
                heading: 'eFaktura vart ikkje godkjent',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om betalinga vart fullført før du prøver om att.',
                check: 'Sjekk transaksjonar',
                checkFuturePayments: 'Sjekk komande betalingar',
            },
            notSigned: {
                heading: 'eFaktura vart ikkje godkjent',
                description: 'eFaktura vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat betaling',
                description: 'Du la til ei betaling på same beløp til denne kontoen tidlegare i dag',
                continue: 'Gå til signering',
                change: 'Endre betalinga',
            },
        },
        RECURRING_TRANSFER: {
            success: 'Fast overføring er oppretta',
            successPlural: 'Faste overføringar vart oppretta',
            successFuture: 'Fast overføring er oppretta',
            error: {
                heading: 'Uff då!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste overføringa vart fullført før du prøver om att.',
                check: 'Sjekk transaksjonar',
                checkFuturePayments: 'Sjekk faste betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Overføringa vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat overføring',
                description: 'Du la til ei fast overføring på same beløp til denne kontoen tidlegare i dag',
                continue: 'Gå til signering',
                change: 'Endre betalinga',
            },
        },
        RECURRING_PAYMENT: {
            success: 'Fast betaling er oppretta',
            successPlural: 'Faste betalingar vart oppretta',
            successFuture: 'Fast betaling er oppretta',
            error: {
                heading: 'Uff då!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste betalinga vart fullført før du prøver om att.',
                check: 'Sjekk transaksjonar',
                checkFuturePayments: 'Sjekk faste betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Betalinga vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat betaling',
                description: 'Du la til ei fast betaling på same beløp til denne kontoen tidlegare i dag',
                continue: 'Gå til signering',
                change: 'Endre betalinga',
            },
        },
        downpayment: {
            success: 'Nedbetalinga vart fullført',
            successPlural: 'Nedbetalingane vart fullført',
            successFuture: 'Nedbetalinga vart lagt til forfall',
            error: {
                heading: 'Uff då!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om nedbetalinga vart fullført før du prøver om att.',
                check: 'Sjekk transaksjonar',
                checkFuturePayments: 'Sjekk komande betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Nedbetalinga vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
            },
            notCompleted: {
                title: 'Duplikat nedbetaling',
                description: 'Du la til ei betaling på same beløp til denne kontoen tidlegare i dag',
                continue: 'Gå til signering',
                change: 'Endre betalinga',
            },
        },
        'efaktura-sharing': {
            success: 'Tilgang til eFaktura vart lagt til',
            successPlural: 'Tilganger til eFakturaene vart lagt til',
            successFuture: '',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Prøv om att seinare!',
                check: '',
                checkFuturePayments: '',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Tilgangsdelinga vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre deling',
            },
            notCompleted: {
                title: '',
                description: '',
                continue: '',
                change: '',
            },
        },
    },
    bankidExpired: {
        header: 'Din BankID er gått ut',
        nativeMessage: 'Viss det er din BankID Mobil som er utgått, kan du endra innloggings- og signeringsmetode sjølv under innstillingar.',
        nativeMessage2: 'Viss det gjeld BankID Brikke, ta kontakt med banken for vidare hjelp.',
        desktopMessage: 'Dette kan vera på grunn av utgått BankID på mobil eller BankID-brikka. Ta kontakt med banken for vidare hjelp.',
        settingsLink: 'Gå til innstillingar',
    },
    stopFuturePaymentInfoMessages: {
        TRANSFER: {
            success: 'Overføringa vart sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om overføringa vart sletta før du prøver på om att.',
                check: 'Sjekk framtidige betalingar',
            },
        },
        PAYMENT: {
            success: 'Betalinga vart sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om betalinga vart sletta før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
        },
        RECURRING_TRANSFER: {
            success: 'Fast overføring vart sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste overføringa vart sletta før du prøver om att.',
                check: 'Sjekk faste betalingar',
            },
        },
        RECURRING_PAYMENT: {
            success: 'Fast betaling vart sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste betalinga vart sletta før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
        },
        FOREIGN_PAYMENT: {
            success: 'Utenlandsbetalinga vart sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste betalinga vart sletta før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
        },
        EFAKTURA: {
            success: 'eFaktura vart sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om eFaktura vart sletta før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
        },
    },
    updateFuturePaymentInfoMessages: {
        TRANSFER: {
            success: 'Overføringa er oppdatert',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om overføringa vart endra før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av overføringa vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        PAYMENT: {
            success: 'Betalinga er oppdatert',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om betalinga vart endra før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av betalinga vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        EFAKTURA: {
            success: 'EFakturaen vart oppdatert',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om eFakturaen vart endra før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av eFakturaen vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        RECURRING_TRANSFER: {
            success: 'Fast overføring er oppdatert',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste overføringa vart endra før du prøver om att.',
                check: 'Sjekk faste betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av den faste overføringa vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        RECURRING_PAYMENT: {
            success: 'Fast betaling er oppdatert',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste betalinga vart endra før du prøver om att.',
                check: 'Sjekk faste betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av den faste betalinga vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
        FOREIGN_PAYMENT: {
            success: 'Utenlandsbetalinga er oppdatert',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om betalinga vart endra før du prøver om att.',
                check: 'Sjekk framtidige betalingar',
            },
            notSigned: {
                heading: 'Oj sann!',
                description: 'Endring av betalinga vart ikkje bekrefta, vil du prøve om att?',
                tryAgain: 'Prøv om att',
                change: 'Endre',
                cancel: 'Avbryt',
            },
        },
    },
    accountOverview: {
        headingMobile: 'Kontoar',
        errorMessageCards: 'Orsak, det har oppstått ein teknisk feil som gjer at du ikkje kan sjå kredittkorta dine akkurat no. Prøv om att om ei tid',
    },
    availableForUse: 'Tilgjengeleg for bruk',
    accountViewErrorMessage: 'Orsak, vi kunne ikkje hente kontoane dine grunna teknisk svikt',
    accountsEmptyInfo: {
        title: 'For å kunne betale må du ha ein brukskonto.',
        paymentAgreementTitle: 'For å kunna oppretta ein AvtaleGiro må du ha ein konto som tillèt dette.',
        recurringPaymentTitle: 'For å kunna oppretta ei fast betaling må du ha ein betalingskonto',
    },
    accountSkipLink: 'Hopp til betal eller overfør',
    advisor: {
        title: 'Din rådgjevar',
        tlf: 'Telefon',
        mail: 'E-post',
        sendEmail: 'Send e-post',
        call: 'Ring',
    },
    avtaleGiroProposals: {
        title: 'Forslag til nye AvtaleGiro',
        update: 'Opprett AvtaleGiro',
        delete: 'Slett forslag',
        new: 'Ny AvtaleGiro',
        sureYouWantToDelete: 'Er du sikker på at du vil sletta dette AvtaleGiro-forslaget?',
        deletemessages: {
            success: 'Forslag er sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om ditt forslag vart sletta før du prøver om att.',
                check: 'Sjekk avtalar',
            },
        },
        proposalToAvtalegiro: 'Forslag til AvtaleGiro',
        onRepeatingEFaktura: 'Ved gjentagande eFaktura kan det ofte vere smart med ein AvtaleGiro i stedet',
    },
    avtaleGiroAgreement: {
        deleteDialogue: 'Er du sikker på at du vil sletta din AvtaleGiro?',
        skipLink: 'Hopp til ny AvtaleGiro',
        title: 'Eksisterande avtalar',
        lastPayment: 'Nyligst betalt:',
        newAvtaleGiro: 'Ny AvtaleGiro',
        retriveAvtaleGiro: 'Hent AvtaleGiro',
        downloadAvtaleGiro: 'Hent AvtaleGiro',
        noAvtalegiro: 'Du har ikkje oppretta nokon AvtaleGiro endå',
        createTitle: 'AvtaleGiro',
        createDescription: 'Opprett AvtaleGiro',
        kidField: 'KID',
        kidPlaceholder: 'Legg til KID',
        maxAmount: 'Maksbeløp',
        limitAmountParagraph: 'Det lønner seg å legga inn litt ekstra som maksbeløp i fall det er prisendringar.',
        limitAmountText: 'Maksbeløp per betaling',
        limitAmountDescription: 'Beløpet på AvtaleGiroen kan ikkje overskride maksbeløpet',
        limitAmountPlaceholder: 'Legg til maksbeløp',
        monthlyLimitAmountText: 'Månadleg maksbeløp',
        monthlyLimitAmountDescription: 'Beløpet er {} maksbeløp per månad, for alle betalinga som blir gjort med denne AvtaleGiroen',
        monthlyLimitAmountPlaceholder: 'Legg til maksbeløp',
        combined: 'samla',
        editMaxAmount: 'Endre maksbeløp',
        noteText: 'Melding',
        notePlaceholder: 'Legg til melding',
        ownText: 'Legg til eige notat',
        ownTextPlaceholder: 'Eige notat',
        amountLimitPlaceholder: 'Legg til eit maksbeløp..',
        deleteAvtaleGiroInfoMessages: {
            success: 'Din AvtaleGiro er sletta',
            error: {
                heading: 'Oj sann!',
                description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om din AvtaleGiro vart sletta før du prøver om att.',
                check: 'Sjekk avtalar',
            },
        },
        redirectLink: {
            header: 'Tips!',
            description: 'Du kan oppretta dette som ein AvtaleGiro viss det er ei betaling du gjer ofte',
            link: 'Sjå forslag til AvtaleGiro',
        },
        update: 'Oppdater',
        delayMessage: 'Ver merksam på at endringar på AvtaleGiro kan ta noko tid før det blir synleg.',
        blocked: 'AvtaleGiro ventar på sletting og kan ikkje endrast',
        avtaleGiroUpdated: 'AvtaleGiro oppdatert',
        avtaleGiroWasStoppedPayment: 'Har du hatt ei stoppa betaling? Det kan vere lurt å sjekke neste verkedagar at betalinga vart betalt.',
        avtaleGiroStoppedPaymentSendAgain: 'Send betalinga om att',
    },
    avtalegiroValidation: {
        emptyKID: 'Du må skriva inn KID',
        missingReceiver: 'Vel mottakar før du fyller inn KID',
        invalidToAccount: 'Det er ikkje mogleg å oppretta AvtaleGiro på vald mottakar',
        existingAvtalegiroAgreement: 'Det er allereie oppretta AvtaleGiro på vald mottakar',
        createSuccess: 'AvtaleGiro er oppretta',
        updateSuccess: 'AvtaleGiro er oppdatert',
        amountTooHigh: 'Maksbeløp kan ikkje vere over {}',
        transactionLimitIsZero: 'Maksbeløp per betaling må vere større enn 0',
        monthlyLimitIsZero: 'Maksbeløp per månad må vere større enn 0',
        monthlyMaxAmountMustBeLargerThanTransactional: 'Månadleg maksbeløp må vere høgare enn maksbeløp per betaling',
        transactionLimitMustBeLessThanMonthly: 'Maksbeløp per betaling må vere lågare enn månadleg maksbeløp',
        error: {
            heading: 'Oj sann!',
            description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om din AvtaleGiro vart fullført før du prøver om att.',
            check: 'Sjekk avtalar',
        },
        notSigned: {
            heading: 'Oj sann!',
            description: 'AvtaleGiro vart ikkje bekrefta, vil du prøve om att?',
            tryAgain: 'Prøv om att',
            change: 'Endre AvtaleGiro',
            cancel: 'Avbryt oppdateringa',
        },
        notSignedUpdate: {
            heading: 'Oj sann!',
            description: 'Endring av AvtaleGiro vart ikkje bekrefta, vil du prøve om att?',
            tryAgain: 'Prøv om att',
            change: 'Endre',
            cancel: 'Avbryt',
        },
        rejected: {
            heading: 'Din AvtaleGiro vart ikkje oppretta',
            description: 'Det ser ut som det er ein annan AvtaleGiro med same KID nummer på denne mottakaren. Sjekk om opplysningane stemmer.',
            tryAgain: 'Endre AvtaleGiro',
        },
        duplicate: {
            heading: 'Din AvtaleGiro vart ikkje oppretta',
            description: 'Det ser ut som du allereie har denne Avtalegiroen i ein annan bank. Trykk på Hent Avtalegiro for å flytta han.',
            fetchAvtalegiroLink: 'Hent AvtaleGiro',
        },
    },
    eFakturaItemType: {
        EFAKTURA: 'eFaktura',
        EFAKTURA_WITH_AVTALEGIRO: 'eFaktura med AvtaleGiro',
        REMINDER: 'Purring',
        ENFORCEMENT_WARNING: 'Purring 2',
        COLLECTION_NOTICE: 'Inkassovarsel',
        CREDIT_NOTE: 'Innbetaling',
        DUNNING: 'Purring 3',
        PAYMENT_REQUEST: 'Purring inkasso',
    },
    taskManager: {
        emptyState: 'Her var det stille og rolig',
        noTasks: 'Du har ingen oppgåver som ventar',
        multipleErrors: {
            title: 'Nokre tenester er ustabile',
            description: 'Vi klarte ikkje hente {}',
            and: 'og',
        },
        errors: {
            outbox: 'betalingar til godkjenning',
            stopped: 'stoppa betalingar',
            documents: 'dokumenter til signering',
            eFaktura: 'eFaktura',
            'loan-application': 'lånesøknadar',
            kredittbanken: 'kredittbanken oppgåver',
        },
    },
    stoppedPayments: {
        title: 'Feila betalingar',
        error: 'Orsak, grunna ein teknisk feil kan du ikkje sjå feila betalingar akkurat no. Prøv om att om ei tid.',
        empty: 'Fant ingen feila betalingar',
        label: {
            UNKNOWN: 'Stoppet',
            INSUFICIENT_FUNDS: 'Manglande dekning på konto',
            EXCEEDING_MAX_LIMIT: 'Betalinga overskrid beløpsgrensa',
            INVALID_CID: 'Ugyldig KID nummer',
            STOPPED_BY_USER: 'Manuelt stoppa',
            CANCELLED_BY_USER: 'Manuelt kansellert',
            INSUFFICIENT_ACCESS: 'Manglar tilgang til konto',
            CANCELLED_BY_BANK: 'Kansellert av banken',
        },
        detailedDescription: {
            UNKNOWN: 'Betaling vart stoppa, sjå over betalinga og prøv om att. Kontakt oss om feilen held fram.',
            INSUFICIENT_FUNDS: 'Betalinga kunne ikkje fullførast grunna manglande dekning på konto. Overfør til konto eller vel ein anna konto.',
            EXCEEDING_MAX_LIMIT: 'Betalinga kunne ikkje fullførast grunna at den overskrid beløpsgrensa. {}',
            INVALID_CID: 'Betalinga kunne ikkje fullførast fordi KID-nummeret brukt i betalinga ikkje var gyldig. Sjå over KID-nummeret og prøv om att.',
            STOPPED_BY_USER: 'Betalinga vart manuelt stoppa av deg eller av nokon andre som disponerer denne kontoen',
            CANCELLED_BY_USER: 'Betalingen vart manuelt kansellert av deg eller nokon andre som har tilgang til denne kontoen.',
            INSUFFICIENT_ACCESS: 'Betalingen kunne ikkje fullførast fordi du manglar bruksrettigheitar til kontoen',
            CANCELLED_BY_BANK: 'Betalinga vart kansellert av banken. Kontakt oss for nærmare informasjon.',
        },
        exeedingMaxLimitAvtalegiro: 'Betalinga overskrid satt beløpsgrense. Etter at du har justert maksbeløpet, kan du sende betalinga til betalingskø.',
        editPaymentLimitsHere: 'Endre beløpsgrensa her {}.',
        goToAccount: 'Gå til kontoen',
        findAvtalegiroHere: 'Finn AvtaleGiroen her.',
    },
    approve: 'Godkjenn',
    balanceAfterPayment: 'Saldo etter {}',
    birthdayMessage: {
        title: 'Hipp hipp hurra! Gratulerer med dagen!',
        title18: 'Hipp hipp hurra for deg som har vorte 18 år!',
        description: 'Gratulerer så mykje med dagen! Vi i banken ønskjer deg ein fantastisk bursdag. Du er ein verdsett kunde hos oss.',
        description18: 'Når du fyller 18 år er det berre du som har tilgang til bankkontoen din. Oppdater kontaktinformasjonen din og få full oversikt!',
        linkText18: 'Kva skjer når du fyller 18 år?',
        buttonText: 'Hurra!',
    },
    biometricType: {
        faceID: 'ansiktsgjenkjenning',
        fingerID: 'fingeravtrykk',
        biometrics: 'biometri',
        none: '',
    },
    bsuAccount: 'bsu-konto',
    bsuDetails: {
        displayYearly: 'Hittil i år',
        displayTotal: 'Totalt',
        amountSaved: 'Du kan spara {} til',
        saldo: 'Total saldo',
        maximumAmount: 'Maksbeløp',
        interestThisYear: 'Renter hittil i år',
        infoMessage: 'For å ta pengar ut av BSU konto må du ta kontakt med oss',
        ageWarningMessage: 'Sia du er over 34 år kan du ikkje lenger setja inn pengar på BSU kontoen din',
        interest: 'Rente BSU',
        accruedInterest: 'Opptjente renter',
        bsuMaxAmountReached: 'Gratulerar - du er eitt steg nærmare eigen bolig!',
        maxAmountThisYear: 'Du har spart årleg maksbeløp for BSU',
        hasRecurringPaymentInfoCardTitle: 'Endre fast sparing i BSU',
        hasRecurringPaymentInfoCardText: 'Du sparer i dag {} kr i månaden.',
        noRecurringPaymentInfoCardTitle: 'Start fast sparing i BSU',
        noRecurringPaymentInfoCardText: 'Du sparer i dag 0 kr i månaden.',
    },
    cancel: 'Avbryt',
    chooseAnotherAccount: 'Vel ein annan konto',
    close: 'Lukk',
    creditCard: 'Kredittkort',
    customerRole: {
        OWNER: 'Eigar',
        DISPOSAL: 'Disponent',
        COLLATERAL: 'Sikkerhet',
        GUARANTOR: 'Garantist',
        COOWNER: 'Medeigar',
        CODEBTOR: 'Medlåntakar',
        GUARDIAN: 'Verje',
        ACCESS: 'Tilgang',
        ADDRESSEE: 'Adresat',
        CREDITOR: 'Kreditor',
        CONTACT: 'Kontakt',
        UNKNOWN: 'Ukjend',
    },
    payToAForeignCountry: 'Betal til utlandet',
    crossBorderPayment: {
        calculatedExchangeRate: 'Førebels berekna beløp',
        exchangeRate: 'Førebels kurs ',
        numbersInNameInfoMessage: 'Her er det berre tillate med namn. Namn som inneheld tal er berre mogleg på bedrifter. Skriv i så fall heile namnet til bedrifta.',
        needOneCharacter: 'Du må ha minst éin bokstav i namnet.',
        amountSubTitle: 'Legg til beløp',
        currencyExchangeError: 'Kunne ikkje henta førebels berekna kurs',
        label: {
            IBAN: 'IBAN',
            BBAN: 'BBAN',
        },
        bic: 'BIC',
        addBic: 'Legg til BIC',
        requiredBicMessage: 'Du må leggja til BIC fordi du ikkje har valt den offisielle valutaen i mottakar landa.',
        statusTitle: 'Utanlandsbetaling er ikkje aktivert',
        statusDescription: 'For å kunna betala til utlandet må du ringa banken og aktivera det først',
        statusButton: 'Kontakt oss',
        desktopAmountTitle: 'Beløp, valuta og dato',
        domesticPaymentWarning: 'Ver merksam på at du har valt å betala i NOK til eit norsk kontonummer. Vi tilrår ikkje å bruka utanlandsbetaling til dette.',
        kinaInfo: 'Merk at du berre kan betala i CNY til bedrifter, ikkje til privatpersonar',
        messageReceiver: 'Legg ved ei melding mottakar',
        accountList: {
            description: 'Her kan du betala til dei fleste land i verda. Husk å ha all informasjon klar før du byrjar. Prisane for utanlandsbetaling finn du i prislista.',
            priceListLink: 'Sjå prisliste',
            noAccountsTitle: 'Du har ingen kontoar hos oss',
            noAccountsDescription: 'For å betala til utlandet må du oppretta ein konto først.',
            createAccountLink: 'Opprett konto',
            payFrom: 'Betal frå',
            label: 'Vel blant kontoane dine',
        },
        categoryList: {
            title: 'Vel kategori',
            label: 'Kva kategori passar best til betalinga di?',
            showMore: 'Vis flerie',
            showLess: 'Vis færre',
            error: 'På grunn av ein teknisk feil klarte vi ikkje å henta lista med kategoriar.',
            errorMessage: 'Du må velja kategori for å kunne gå vidare',
        },
        description: {
            title: 'Skildring på betaling',
            placeholder: 'Skriv her',
            descriptionLabel: 'Beskriv kva betalinga gjeld',
            messageLabel: 'Legg ved ei melding til mottakar',
            descriptionError: 'Du må skriva ei skildring av betalinga',
            messageError: 'Du må skriva ei melding til mottakaren',
            tooManyCharacters: 'Du kan ikkje ha meir enn {} teikn i skildringa.',
        },
        newReceiver: {
            title: 'Legg til mottakar',
            subTitle: 'Kvar skal pengane?',
            creditorInfo: 'Om mottakar',
            receiverNameLabel: 'Fullt namn/firmanamn',
            createNewReceiverTab: 'Utland',
            countryLabel: 'Mottakars land',
            countryPlaceholder: 'Søk på land',
            ibanLabel: 'IBAN',
            bicLabel: 'SWIFT eller BIC',
            bbanLabel: 'BBAN',
            nationalIdLabel: 'Bankkode',
            addressPlaceholder: 'Gatenamn og husnummer',
            address: 'Adresse',
            receiverAddress: 'Adressa til mottakar',
            bankCountry: 'Landet til banken',
            receiverBank: 'Banken til mottakar',
            errorCountryTitle: 'Orsak!',
            errorCountry: 'På grunn av ein teknisk feil klarte vi ikkje å henta lista med land.',
            errorCountryDetails: 'Orsak, det har skjedd ein teknisk feil så vi klarte ikkje å henta detaljar for landet du valde.',
            errorReceiverList: 'Orsak, grunna ein teknisk feil klarte vi ikkje å henta mottakarane dine',
            errorBankValidation: 'Orsak, det har skjedd ein teknisk feil så vi klarte ikkje å henta informasjon om mottakarbanken.',
            emptyBankValidation: 'Kontonummer er gyldig, men vi finn ikkje informasjon om mottakars bank. Kontakt oss for å betala til denne mottakaren.',
            errorValidToPayReceiver: 'Det er dessverre ikkje mogleg å betala til denne mottakaren. Ta kontakt med oss viss du treng hjelp.',
            errorIban: 'Du har skrive eit ugyldig IBAN nummer',
            errorIbanValidation: 'Orsak, det har skjedd ein teknisk feil ved valideringen av bankinformasjonen. Sjekk om korrekt informasjon er skrive inn.',
            errorIbanCountryCode: 'IBAN nummer er ikkje gyldig for det landet du har valt',
            errorValidation: 'Du har skrive ugyldig informasjon',
            missingAccountNumber: 'Du må fylle ut kontonummer for å kunne gå vidare',
            validForPaymentError: 'Det er ikkje mogleg å gjera ei betaling til det valde landet.',
            paymentOptions: 'Vel betalingstype',
            accountNumberError: 'Kontonummer er ikkje gyldig',
            bicError: 'BIC/SWIFT er ikkje gyldig',
            missingBic: 'Du må fylle ut BIC/SWIFT for å kunne gå vidare',
            missingBankBic: 'Banken støttar ikkje betalingar frå utlandet',
            missingNationalId: 'Du må fylle ut bankkode for å kunne gå vidare',
            missingCreditorDetails: 'Du må fylle ut adresse',
            missingPostCode: 'Du må fylle ut postnummer',
            missingTown: 'Du må fylle ut poststad',
            receiverNameError: 'Du må fylle ut eit namn på mottakar',
            selectedCountryError: 'Du må velja eit land',
            nationalIdError: 'Bankkoden er ikkje gyldig',
            bankDetailsError: 'Orsak, vi klarte ikkje å henta nødvendig informasjon om landet til banken.',
        },
        summary: {
            title: 'Sjå over og betal',
            payFrom: 'Du betaler frå {}',
            payTo: ' til {}',
            payToCountry: 'i {} {}',
            showSummary: 'Sjå heile oppsummeringa',
            closeSummary: 'Lukk oppsummeringa',
            receiver: 'Mottakar',
            amount: 'Beløp',
            amountDateTitle: 'Beløp, valuta og dato',
            messageAndDescription: 'Skildring og melding',
            messageToReceiver: 'Melding til mottakar',
            category: 'Kategori',
            chosenCategory: 'Vald kategori',
            fee: 'Gebyret er',
            feeMessage: 'blir delt mellom betaler og mottakar',
            feeDescription: 'Gebyret for utanlandsbetaling blir {}',
            paymentPeriod: 'Mottakar får vanlegvis pengane innan 1-2 dagar. For land i andre tidssoner kan det ta lengre tid',
            blockedErrorMessage: 'Betalinga kan dessverre ikkje gjennomførast',
            invalidAccountNumber: 'Ugyldig kontonummer til mottakar',
        },
        invalidCurrency: 'Ugyldig valuta',
    },
    currencyField: {
        label: 'Valuta',
        searchPlaceholder: 'Søk etter valuta',
        title: 'Overføringsvaluta',
        description: 'Vel kva valuta du ynskjer skal bli trekt frå kontoen din',
        recommended: 'Anbefalt',
        allCurrency: 'Alle valuta',
        transferCurrencyDescription: 'Du har valt ein annan valuta enn banken kan motta. Du må derfor velje ein overføringsvaluta.',
        transferCurrencySubTitle: 'Vel overføringsvaluta',
        errorTransferCurrency: 'Orsak, det har skjedd ein teknisk feil så vi klarte ikkje å henta lista med valuta.',
        missingTransferCurrency: 'Du må velja ein overføringsvaluta',
    },
    chargeBearerField: {
        title: 'Omkostninger',
        description: 'Det er vanleg å dela på kostnadene ved utanlandsbetaling. Det betyr at du som sender betaler i banken og mottakaren din betaler eventuell kostnad i banken sin.',
        infoMessage: 'Merk at vi ikkje kjenner til kostnadene i mottakars bank. Prisane for utanlandsbetaling finn du i prislista.',
    },
    chargeBearerOptions: {
        SHARED: 'Delt',
        SENDER: 'Du betaler',
        RECEIVER: 'Mottakar betaler',
    },
    chargeBearerFeeDescription: {
        SHARED: 'delt mellom deg og mottakar',
        SENDER: 'betalt av deg',
        RECEIVER: 'betalt av mottakar',
    },
    chargeBearerSelectOptions: {
        SHARED: 'Delte omkostninger',
        SENDER: 'Du betaler omkostningene',
        RECEIVER: 'Mottakar betaler omkostningene',
    },
    delete: 'Slett',
    details: 'Detaljar',
    disableAvtaleGiroChanges: {
        changeAndDeleteUnavailable: 'Det er dessverre ikkje mogleg å sletta eller endra på AvtaleGiro for augneblinken.',
        creationUnavailableTitle: 'Orsak',
        creationUnavailableDescription: 'Det er dessverre ikkje mogleg å oppretta AvtaleGiro for augneblinken.',
    },
    confirmDelete: 'Ja, slett',
    date: 'Dato',
    editDisplayAndOrderOfAccounts: 'Endre visning og rekkefølgje på kontoar',
    editAccounts: {
        view: 'Rediger kontovisning',
        info: 'Merk kontoane du ønskjer å sjå på framsida, og hald og dra på kontoane for å endra rekkjefølgje. Du kan også bruka pilene. Rekkjefølgja vil gjelda alle stader der kontoane dine blir lista ut.',
        header: 'Kontovisning',
        addNewGroup: 'Lag ny gruppe',
        remove: 'Slett',
        change: 'Endre',
        confirm: 'Ferdig',
        moveUp: 'flytt opp',
        moveDown: 'flytt ned',
        technicalError: 'teknisk svikt',
        errorNotSaved: 'Orsak, endringane dine vart ikkje lagra grunna ein teknisk svikt. Prøv igjen om ei tid.',
        accountsError: 'Orsak, du kan ikkje endra visning og rekkefølgje på kontoane dine akkurat no grunna ein teknisk svikt. Prøv igjen om ei tid.',
        cantDisable: 'Du må vise minst ein konto på framsida.',
        success: 'Kontolista er oppdatert',
        newGroupName: 'Ny gruppe',
        holdingAccount: 'Fondskonto',
    },
    eFaktura: {
        eFaktura: 'eFaktura',
        eFakturaChangedDate: 'Dato på eFaktura vert endra til i dag',
        isDeleted: 'eFaktura er sletta',
        seeAll: 'Sjå alle eFaktura',
        sureYouWantToDelete: 'Er du sikker på at du vil sletta denne eFakturaen?',
        noValidFromAccounts: 'Du har ikkje ein konto som du kan betale eFaktura ifrå.',
        approve: 'Godkjenn',
        eFakturaInvalidAccount: 'Du må ha brukskonto for å betale eFaktura',
        notice: {
            EFAKTURA: undefined,
            EFAKTURA_WITH_AVTALEGIRO: 'Denne betalinga blir automatisk trekt som ei AvtaleGiro',
            REMINDER: 'Ver merksam på at dette er ei purring. Viss du allereie har betalt kan du sletta denne.',
            ENFORCEMENT_WARNING: 'Ver merksam på at dette er eit varsel om at betalinga blir oversendt til namsmann. Viss du allereie har betalt kan du sletta denne.',
            COLLECTION_NOTICE: 'Ver merksam på at dette er eit inkassovarsel. Viss du allereie har betalt kan du sletta denne.',
            CREDIT_NOTE: 'Dette er eit varsel om tilbakebetaling. Denne skal ikkje betalast',
            DUNNING: 'Ver merksam på at dette er ei purring. Viss du allereie har betalt kan du sletta denne.',
            PAYMENT_REQUEST: 'Ver merksam på at dette er ei purring på inkasso. Viss du allereie har betalt kan du sletta denne.',
        },
        confirmPayment: 'Ja, betal',
        confirmationDialogTitle: 'Er du sikker på at du vil betale denne delte eFakturaen?',
        delete: 'Slett',
    },
    eFakturaAgreement: {
        jttaTitle: 'eFaktura',
        jttaDescription: 'Med eFaktura får du rekningane digitalt, same kvar du er. Du har full kontroll og oversikt til kvar tid.',
        jttaAriaLabel: 'Ja takk til alle eFaktura',
        dialogTitle: 'Er du sikker på at du vil skru av eFaktura?',
        dialogDescription: 'Vêr merksam på at du ikkje lenger vil motta eFaktura frå nokon leverandørar. Rekningar kan bli sendt i posten, epost, eller digipost istaden.',
        dialogConfirmation: 'Ja',
        errorLabel: 'Ojsann, noko gjekk gale! Prøv om att litt seinare. Kontakt oss om feilen held fram.',
        emailValidation: 'E-postadressa er ikkje gyldig',
        emailRequired: 'Du må fylla inn e-postadresse',
        emailField: {
            label: 'E-post',
            placeholder: 'Legg til e-postadresse',
        },
        mobileNumberField: {
            label: 'Mobilnummer',
            placeholder: 'Legg til mobilnummer',
        },
        update: 'Oppdater',
        historyLink: 'Historikk',
        reservationsLink: 'Reservasjonar',
        notificationsLink: 'eFaktura-varslingar',
        archiveLink: 'eFaktura arkiv',
    },
    eFakturaHistory: {
        title: 'eFaktura historikk',
        description: 'Her finn du ei oversyn over kven du har fått eFaktura frå dei siste 16 månadene.',
        error: 'Orsak, vi kunne ikkje hente eFaktura historikken dine grunna teknisk svikt',
        noCreditors: 'Her har det ikkje skjedd stort!',
    },
    eFakturaNotifications: {
        togglePushLabel: 'Få varslingar på push',
        toggleEmailLabel: 'Få varslingar på epost',
        off: 'Av',
        noAgreementInfo: 'For å få varslingar på epost må du gå tilbake og skru på alltid eFaktura.',
        goBack: 'Gå tilbake',
        differentEmailWarning: {
            header: 'Obs!',
            text: 'Denne adressa er annleis enn den du har sett under Kontaktinfo og ID. Denne epostadressa vil berre gjelda eFaktura-varslingar.',
            linkText: 'Til Kontaktinfo og ID',
        },
    },
    eFakturaReservation: {
        title: 'Reserver deg mot eFaktura',
        description: 'Her kan du reservera deg mot eFaktura frå ulike bedrifter du har mottatt eFaktura frå dei siste 16 månadene.',
        error: 'Det har skjedd ein teknisk feil som gjer at det ikkje er mogleg å legga inn eller sjå reservasjonar akkurat no.',
        noCreditors: 'Du har ingen bedrifter du kan reservera deg mot',
        noBlockedCreditors: 'Du har ikkje reservert deg mot å få eFaktura frå nokon',
        yourReservations: 'Reservasjonane dine',
        unblockError: 'Det har skjedd ein teknisk feil, så vi klarte ikkje å sletta reservasjonen.',
        confirmUnblock: 'Er du sikker på at du vil sletta reservasjonen?',
        blockSuccess: 'Reservasjon mot eFaktura frå {} er lagt til!',
        blockError: 'På grunn av ein teknisk feil klarte vi ikkje å legga inn reservasjonen.',
        youChose: 'Du har valt:',
        blockDescription: 'Etter at du har reservert deg, vil {} ikkje kunna senda deg eFaktura lenger. Då kan faktura bli send i posten, epost eller digipost.',
        confirmBlock: 'Reserver deg',
    },
    eFakturaAccount: {
        title: 'Vel betalingskonto for eFaktura',
        description: 'Du kan når som helst endra betalingskonto viss du vil byta til ein annan konto.',
        label: 'Betalingskonto',
        success: 'Betalingskonto for eFaktura er vald',
        chosenEFakturaAccount: 'Du har valt {} som betalingskonto',
        error: 'eFaktura-konto vart dessverre ikkje lagt til, ver vennleg og prøv om att',
        notSetTitle: 'Ingen valde betalingskonto',
        notSetDescription: 'Ønskjer ikkje å ha ein eigen spesifisert betalingskonto',
        unselectedSuccess: 'Betalingskonto er ikkje sett',
        noAccountsTitle: 'Du treng ein konto for å velja betalingkonto',
        noAccountsText1: 'Du har ingen kontoar enno. Dette treng du for å kunna velja ein spesifikk betalingskonto.',
        noAccountsText2: 'Blir ikkje viste kontoane dine, er feilen på vår side. Forsøk gjerne igjen om ein time.',
    },
    eFakturaSharing: {
        shareEfaktura: 'Del eFaktura',
        giveAnotherCustomerAccess: 'Gi ein annan kunde tilgang til dine eFaktura',
        shareYourEfaktura: 'Del dine eFaktura',
        sharingWith: 'Deler med',
        sharingWithPlaceholder: 'Delt med {}',
        andMore: 'og flere...',
        sharingWithYou: 'Deler med deg',
        whoDoYouWantToShareWith: 'Kven ønskjer du å dele med?',
        name: 'Fullt namn',
        writeName: 'Skriv fullt namn',
        ssn: 'Fødselsnummer',
        writeSSN: '11 siffer',
        howManyEfakturasToShare: 'Kor mange eFaktura ønskjer du å dele?',
        amountSelected: {
            all: 'Alle',
            some: 'Kun nokon',
        },
        chooseEfakturasToShare: 'Vel eFaktura som skal delast',
        noEfakturas: 'Du har ingen eFaktura-avtalar per i dag. Vi velger derfor "Alle" for deg, slik alle framtidige avtalar blir valt.',
        userAlreadyInGiven: 'Du har allereie delt eFaktura med denne kunden, vil du heller endre hva du deler?',
        editSharing: 'Endre delingsavtalen',
        deleteSharing: 'Slett deling',
        errorFetchingEfaktura: 'Noko gjekk gale ved henting av eFaktura-avtalar. Vi velger derfor “Alle” for deg, slik at alle framtidige avtalar blir delt. Du kan også prøve om att.',
        allEfaktura: 'Alle eFaktura',
        confirmDelete: 'Er du sikker på at du vil slette delingsavtalen med {}?',
        confirmDeleteDescription: 'Sletting er permanent og du kan ikkje angre.',
        receiverDeleted: 'Delingsavtalen er slettet',
        userNotFound: 'Vi fant ikkje brukaren du leitar etter. Kontakt oss om feilen held fram.',
        chooseFromCompanies: 'Vel frå bedrifter som har sendt deg eFaktura tidlegare.',
        orgNumber: 'Org nr {}',
        confirmationText: {
            all: 'Du gir {} tilgang til alle eFakturaene dine',
            some: 'Du gir {} tilgang til eFaktura frå desse bedriftane:',
        },
        organisationNumber: 'Organisasjonsnummer',
        deleteCompanyFromShareList: 'Slett {} frå delelista',
        summaryNotice: 'Merk at det kan ta 1 - 2 verkedagar før eFaktura vert delt.',
        giveAccess: 'Gje tilgang',
        validationErrors: {
            userNotFound: 'Ugyldig brukar',
            ssn: {
                invalidLength: 'Fødselsnummeret må vere 11 siffer langt',
                NaN: 'Fødselsnummeret må berre være tall',
            },
            name: {
                required: 'Skriv inn fullt namn',
                error: {
                    NOT_FOUND: 'Fann ikkje kunden. Merk: de må ha same bank.',
                    SAME_PERSON: 'Du har søkt på deg sjølv. Du har allereie tilgang til eFakturaen.',
                    INVALID: 'Ugyldig fødselsnummer',
                    ERROR_OCCURED: 'Ein feil oppstod. Prøv på nytt.',
                },
            },
            amountSelected: {
                required: 'Du må velje ein av alternativa',
                alreadySharedEverything: 'Du har allereie delt alle eFaktura med denne kunden.',
            },
            selected: {
                tooFewSelected: 'Du må velje minst ein eFaktura å dele',
            },
        },
        noSharedEfakturaInfo: {
            header: 'Her var det tomt',
            noReceivedBody: 'Det er visst ingen eFaktura som er delt med deg',
            noGivenBody: 'Du deler ikkje eFaktura med nokon enno',
        },
    },
    eFakturaEmpty: {
        title: 'Her er det heilt tomt',
        description: 'Det er ingen eFaktura som treng godkjenning akkurat no.',
        link: 'Til framsida',
    },
    effectiveInterestInfo: {
        title: 'Korleis blir effektiv rente berekna?',
        description1: 'Effektiv rente visar den totale kostnaden for lånet. Ved berekning inkluderar den kjende kostnadar tilbake i tid og fram i tid for nominell rente, etableringskostnadar og termingebyr.',
        description2: 'Det betyr at framtidige renteendringar som er varsla, men ikkje har tredd i kraft også er inkluderte i berekninga. Renta kan derfor i periodar der lånerenter går opp eller ned verka kunstig høg eller for låg i forhold til den nominelle renta.',
    },
    errors: {
        somethingWentWrong: 'Noko gjekk gale!',
        somethingWentWrongFetchingReceivers: 'Det har skjedd ein teknisk feil, så vi klarte ikkje å henta mottakarane dine akkurat no.',
        somethingWentWrongFetchingSomeReceivers: 'Vi klarar ikkje å visa mottakarar frå {} akkurat no',
        somethingWentWrongDeletingReceiver: 'Orsak, vi klarte ikkje å sletta mottakaren',
        somethingWentWrongChangingReceiver: 'Orsak, vi klarte ikkje å endra mottakaren',
        avtaleGiroErrorFetchingAccounts: 'For å oppretta ein AvtaleGiro treng du ein brukskonto. Dessverre klarer vi ikkje å henta kontoane dine akkurat no.',
        ohNo: 'Ikkje bra!',
        oops: 'Uff då!',
        sorry: 'Orsak!',
        defaultMessage: 'Orsak, det oppstod ein teknisk feil. Ver vennleg og prøv igjen om ei tid.',
        rcid: 'Feilkode',
    },
    createdBy: 'Oppretta av {}',
    you: 'deg',
    paymentsForApproval: 'Betalingar til godkjenning',
    signAndAddApproval: 'Signer og send til godkjenning',
    approveAndPay: 'Godkjenn og betal',
    needsAdditionalApproval: 'Betalinga må godkjennast av andre. Legg til godkjenning om du ynskjer å samla opp betalingane før du signerer.',
    outbox: {
        approvePayment: 'Godkjenn betaling',
        removeApproval: 'Fjern godkjenning',
        paymentsYouCanSignDomestic: 'Betalingar du kan signere',
        paymentsYouCanSignCrossBorder: 'Utenlandsbetalingar du kan signere',
        paymentsOthersMustSign: 'Betalingar andre må signere',
        mainPageLink: 'Gå til framsida',
        deleteApprovalItemFailed: 'Vi beklagar, dette gjekk ikkje heilt etter planen. Sjekk om betalinga vart sletta før du prøvar om att.',
        deleteApprovalItemSuccess: 'Betalinga vart fjerna',
        unapproveItemFailed: 'Vi beklagar, dette gjekk ikkje heilt etter planen. Sjekk om godkjenninga vart fjerna på betalinga før du prøvar om att.',
        unapproveItemSuccess: 'Godkjenninga vart fjerna',
        confirmUnapprove: 'Ja, fjern godkjenning',
        emptyList: 'Du har ingen betalingar som krev godkjenning',
        edit: 'Endre',
        editOrDelete: 'Endre eller slett',
        editPayment: 'Endre betaling',
        editSuccess: 'Betalinga vart endra!',
        deleteError: 'Vi klara ikkje sletta betalinga akkurat no. Prøv om att no, eller litt seinare.',
        editError: 'Vi klara ikkje å endre betalinga. Prøv om att no, eller litt seinare.',
        errorContactUs: 'Kontakt oss om feilen held fram.',
        retryEdit: 'Ja, hald fram',
        delete: 'Slett',
        deletePayment: 'Slett betalinga',
        saveChanges: 'Lagre endringane',
        checkboxLabel: 'Hak av for å leggja i betalingsliste',
        waitingForNrOfSignings: 'Ventar på {} godkjenningar',
        youHaveApproved: 'Du har godkjent betalinga',
        plannedPaid: 'Planlagt betalt',
        totalForOthersApproval: 'Totalt til andres godkjenning {}',
        totalForYourSigning: 'Totalt til din godkjenning {}',
        noSelectedPayments: 'Du må velje minst èin betaling',
        paidBy: 'Betalt av {}',
        removeChosen: 'Fjern valde',
        chooseAll: 'Vel alle',
    },
    approveAllPaymentLimitValidation: 'Maksgrense for betalingar er {} kr i månaden, med desse betalingane går du {} kr over maksgrensa di. For å gå vidare må du endra på ein eller fleire av betalingane eller beløpsgrensa di',
    forceUpdateModal: {
        title: 'Mobilbanken må oppdaterast',
        description: 'Du må oppdatera til siste versjon for å framleis nytta mobilbanken.',
        buttonText: 'Oppdater no',
    },
    from: 'Frå',
    futurePaymentDetails: {
        fakedLoanPayment: {
            warning: 'Dette er ei forventa nedbetaling på lånet ditt. Det er ikkje mogleg å endra eller slette denne.',
        },
        normal: {
            noEditWarning: 'Denne betalinga kan dessverre ikkje endrast.',
        },
        foreignPayment: {
            noEditWarning: 'Det er dessverre ikkje mogleg å endra ei framtidig utanlandsbetaling. Viss noko ikkje er rett, må du sletta betalinga og oppretta den på nytt.',
        },
        recurringPayment: {
            editLink: 'Endre betaling',
            editWarning: 'Det er dessverre ikkje mogleg å endra ei framtidig betaling enno. Det kan endrast frå oversikt over faste betalingar.',
        },
        noReject: {
            editWarning: 'Denne betalinga er det ikkje mogleg å sletta eller endra. Kontakt banken for hjelp til å sletta denne betalinga.',
        },
        calculatedAmount: 'Førebels berekna beløp',
        amountInCurrency: 'Beløp i transaksjonsvaluta',
        paidBy: 'Betalt av',
        change: 'Endre',
    },
    futurePayments: {
        balanceToday: 'Saldo i dag ',
        noFuturePayments: 'Du har ingen framtidige betalingar på',
        paidBy: 'Betalt av {}',
        approvedBy: 'Godkjent av {}, {}',
    },
    futurePaymentsList: {
        ariaLabel: 'Filtrer framtidige betalingar',
        totalIn: 'Totalt inn',
        totalOut: 'Totalt ut',
        title: 'Framtidige betalingar',
        future: 'Framtidige',
        payment: 'betaling',
        payments: 'betalingar',
        paymentsLeftThisMonth: '{} {} igjen neste 30 dagar',
        removeAllSelected: 'Nullstill',
        selectAll: 'Velg alle',
        removeChosenAccounts: 'fjern filter: ',
        chooseAccount: 'Velg konto',
        chosenAccount: '{} valgt konto',
        chosenAccounts: '{} valgte kontoar',
        choose: 'Velg',
        total: 'Til saman {}',
        noHits: 'Fant ingen framtidige betalingar',
        couldNotGetFuturePayments: 'Orsak, vi kunne ikkje hente dine framtidige betalingar grunna teknisk svikt',
    },
    futurePaymentsEFaktura: {
        it: 'Han',
        theFirst: 'Den første',
        hasDeadlineToday: 'har frist i dag',
        hasDeadlineTomorrow: 'har frist i morgon',
        hasDeadlineOn: 'har frist på',
        hasDeadline: 'har frist',
        hadDeadlineYesterday: 'hadde frist i går',
        hadDeadlineLast: 'hadde frist førre',
        hadDeadline: 'hadde frist',
        youHave: 'Du har',
        newSingular: 'ny',
        newPlural: 'nye',
    },
    paymentItemStatus: {
        WAITING_FOR_SIGNING: 'Trenger godkjenning',
        STOPPED: 'Stoppet betaling',
        REJECTED: 'Avvist betaling',
        EXPIRED: 'Utløpt betaling',
        PENDING_PAYMENT: 'Til betaling',
        UNKNOWN: '',
    },
    paymentSubStatus: {
        EXCEEDING_MAX_LIMIT: 'Betalinga overskrid beløpsgrensa',
        INSUFFICIENT_ACCESS: 'Ingen tilgang',
        INSUFICIENT_FUNDS: 'Mangler dekning på konto',
        INVALID_CID: 'Ugyldig KID nummer',
        STOPPED_BY_USER: 'Stoppet av brukar',
        CANCELLED_BY_BANK: 'Stoppet av banken',
        CANCELLED_BY_USER: 'Stoppet av brukar',
    },
    insufficientFundsFromOwnAccount: 'Manglar dekning på avsendarkonto',
    futurePaymentType: {
        TRANSFER: 'Overføring',
        PAYMENT: 'Betaling',
        FOREIGN_PAYMENT: 'Utanlandsbetaling',
        RECURRING_PAYMENT: 'Fast betaling',
        RECURRING_TRANSFER: 'Fast overføring',
        AUTO_PAYMENT: 'AvtaleGiro',
        EFAKTURA: 'eFaktura',
        UNKNOWN: '',
    },
    futurePaymentOwnerSuffix: 'sin konto',
    stopFuturePayment: {
        delete: 'Slett',
        confirm: 'Ja, slett',
        cancel: 'Avbryt',
        header: 'Er du sikker på at du vil sletta denne {}?',
        headerParamTransfer: 'overføringa',
        headerParamPayment: 'betalinga',
        headerParamEFaktura: 'eFaktura',
    },
    futurePaymentsErrorMessage: 'Orsak, grunna ein teknisk feil kan du ikkje sjå framtidige betalingar akkurat no. Prøv igjen om ei tid.',
    futurePaymentTitle: {
        payment: 'Betaling',
        transfer: 'Overføring',
    },
    immediatePayment: {
        title: 'Straksbetaling',
        info: 'Med straksbetaling kjem pengane på konto til mottakar i løpet av få sekund.',
        priceInfo: 'Vær oppmerksam på at det kan tilkomme gebyr ved straksbetaling.',
        priceButton: 'Sjå prislistene våre',
        stepUpRequired: {
            title: 'Auka tryggleik',
            text1: 'Straksbetaling krev høg tryggleik. For å gjennomføra betalinga ønskjer vi å gjera ei biletverifisering av deg. Det går raskt, og når du er ferdig så opnar vi samtidig opp meir funksjonalitet for deg i mobilbanken.',
            text2: 'NB! Når du er verifisert må du starta betalingsprosessen om att.',
            text3: 'Du kan velja å betala på vanleg måte. Då vil betalinga gå litt saktare og det vil ta noko lengre tid før mottakar får pengane på kontoen.',
            start: 'Få full tilgang',
            back: 'Legg til som normal betaling',
        },
    },
    invalidMessage: 'Denne meldinga er ikkje gyldig.',
    keepAlive: {
        title: 'Er du der?',
        description: 'Av omsyn til trygginga di sjekkar vi om du framleis er her etter ei viss tid.',
        confirmationButtonText: 'Ja, eg er her',
    },
    lastLogin: 'Sist innlogga',
    loanAccount: 'lånekonto',
    loanDetails: {
        error: 'Orsak, vi kunne ikkje hente lånedetaljane dine grunna teknisk svikt',
        nameOfLoan: 'Namn på lån',
        loanOwners: 'Låntakarar',
        noLoan: 'Fann ikkje lån',
        interest: 'Rente',
        paymentPlanMessage: 'Nedbetalingsplan for lån er ikkje på plass endå, vi jobbar med saka.',
        effectiveInterest: 'Effektiv rente {} %',
        nominalInterst: 'Nominell rente',
        amount: 'Beløp',
        nextPayment: 'Neste innbetaling',
        initialAmount: 'Opprinneleg lånebeløp',
        plannedDownpaymentDate: 'Nedbetalt dato',
        debitAccount: 'Belastingskonto',
        downpaymentDay: 'Trekkdato',
        installmentAmount: 'Terminbeløp',
        editPaymentDateAndPaymentAccount: 'Endre trekkdato og betalingskonto her',
        seeDetails: 'Sjå lånedetaljar',
        moreInformationAboutThisLoan: 'Meir informasjon om dette lånet',
    },
    downpayment: {
        cannotDoDownpayment: 'Du kan ikkje gjere ein ekstra innebetaling for eit fastrente lån.',
        noTransferFromAccount: 'Du har ingen konto du kan gjere denne nedbetalinga frå.',
    },
    loanDownpaid: 'Lånet er nedbetalt.',
    loanError: 'Orsak, vi kunne ikkje hente lånet ditt grunna teknisk svikt.',
    loanOwners: 'Låneeeigarar',
    loanName: 'Lånenamn',
    loanOverviewErrorMessage: 'Det har oppstått ein teknisk feil som kan gjere at nokre av låna dine ikkje visast.',
    loanOverviewNoLoansHeader: 'Du har ingen lån hos oss',
    loanOverviewNoLoansText: 'Livet forandrar seg - og det gjer lånebehova dine også. Vi er her for å hjelpe deg.',
    loanRepaymentPlan: {
        viewRepaymentPlan: 'Sjå nedbetalingsplan',
        error: 'Orsak, vi kunne ikkje henta nedbetalingsplan grunna teknisk svikt',
        period: 'Periode',
        youPay: 'Du betaler',
        instalment: 'Avdrag',
        charges: 'Gebyr',
        interest: 'Renter',
        balance: 'Resterande lån',
    },
    loanEdit: {
        edit: 'Administrer lånet',
        editAccountToPayFrom: 'Endre konto å betala frå',
        editDebitAccount: 'Endre trekkonto',
        chooseDebitAccount: 'Vel kontoen lånet skal trekkjast frå',
        dayEachMonth: 'Den {}. kvar månad',
        dayEachYear: 'Den {}. kvart år',
        dayEachHalfYear: 'Den {}. kvart halvår',
        dayEachCustom: 'Den {}. kvar {}. dag',
        editDay: 'Endre trekkdato',
        chooseDay: 'Vel dagen du ynskjer at lånet skal verte trekt',
        save: 'Lagre',
        everyDay: ' kvar dag',
        dayPrefix: 'Den',
        onlyFutureDates: 'Fordi lånet ikkje allereie er sendt til betaling denne månaden, er det berre mogleg å velja trekkdato minimum ein dag fram i tid.',
        editInfoMessage: 'Husk at når du endrar trekkdato, vil neste betaling ta omsyn til endra renteberekning.',
        cantBeChanged: 'Lånetrekket er for nær forfall og kan ikkje endrast før etter forfall',
        errors: {
            debitAccountDefaultError: 'Orsak, vi kunne ikkje endre trekkonto for lånet ditt grunna teknisk svikt.',
            paymentDayDefaultError: 'Orsak, vi kunne ikkje endre trekkdato for lånet ditt grunna teknisk svikt.',
            dayBiggerThanOrLessThan: 'Trekkdato må være større enn {} og {} eller mindre',
            mustChooseDate: 'Du må velje ein trekkdato',
            alreadyChosen: 'Denne datoen er allereie valt',
            biggerThan: 'Trekkdato må være større enn {}',
            lessThan: 'Trekkdato må være {} eller mindre',
        },
    },
    logout: 'Logg ut',
    login: {
        toggleBiometrics: 'Innlogging og signering med {}',
        biometricsError: 'Orsak, noko gjekk gale. Prøv igjen seinare',
        changeBank: 'Endre hovudbank',
        changeBankAndAgreement: 'Endre hovudbank/hovudavtale',
        changeAgreement: 'Endre hovudavtale',
        myActivations: 'Mine einingar',
        loginAndSigning: 'Innlogging- og signeringsmetode',
        signingAndLoginChoice: '{} er valt for innlogging og signering.',
        signingAndLoginChoiceDifferent: 'Du loggar inn med {} og signerer med {}',
        stepUp: {
            title: 'Auka tryggleik',
            description: 'Få full tilgang til alle dagens og kommande funksjonar i mobilbanken gjennom å gjera ei rask biletgjenkjenning',
        },
    },
    loginAndSigning: {
        chooseLoginMethodDescription: 'Vel korleis du ønskjer å logga deg inn. PIN-koden laga du ved aktivering av mobilbanken. Då fekk du også valet om biometrisk pålogging.',
        chooseSigningMethodDescription: 'Vel korleis du ønskjer å signera for å godkjenna betalingar og liknande i mobilbanken.',
        step: 'Steg {} av 2',
        chooseSigningMethodTitle: 'Vel signeringsmetode',
        chooseLogin: 'Vel innlogginsmetode',
        toFrontPage: 'Til framsida',
        headerSuccess: 'Signerings- og innlogginsmetode er satt!',
        saveAndComplete: 'Lagre og fullfør',
        saveAndContinue: 'Lagre og gå vidare',
        errorMessageBiometryDisabled: 'For å velja biometri må det vera skrudd på i innstillingar på telefonen',
        infoMessageEnableBiometry: 'For å kunna velja å signera med biometri, må du også ha biometrisk innlogging. Blir endra i førre steg.',
        signingMethods: {
            PIN: 'PIN-kode',
            BANKID: 'BankID',
            BIOMETRIC: 'Biometri',
        },
        errorMessageSigningMethod: 'Signeringsmetoden kunne ikkje lagrast på grunn av ein teknisk feil.',
        errorMessageNoSigningMethodChosen: 'Du må velja ein signeringsmetode for å fullføra',
        errorMessageNoLoginMethodChosen: 'Du må velja ein innlogginsmetode for å gå vidare',
        errorMessage: 'Orsak, noko gjekk gale. Prøv igjen seinare',
    },
    kidNumber: 'KID',
    payment: 'Betal',
    payNow: 'Betal nå',
    transferNow: 'Overfør nå',
    applyForAvdragsfrihet: 'Søk om avdragsfriheit',
    addPaymentForApproval: 'Legg til godkjenning',
    paymentForApproval: 'Betalinga vart lagt til godkjenning',
    paymentSettings: {
        eFaktura: 'eFaktura',
        avtaleGiro: 'AvtaleGiro',
        addAndEditAgreements: 'Legg til og endre avtalane dine',
        paymentLimits: 'Beløpsgrenser',
        editPaymentLimits: 'Endre beløpsgrenser',
    },
    payWithBankId: 'Betal',
    priorityField: {
        title: 'Vel prioritet',
        label: 'Prioritet',
        description: 'Betalingar merka “haster” vil få dagens vekslingskurs og normalt vera på mottakars konto same eller neste dag. Ekstra kostnader kan finnast.',
    },
    priorityOption: {
        STANDARD: 'Normal',
        URGENT: 'Haster',
    },
    pushNotifications: {
        label: 'Pushvarslingar',
        mainSwitch: 'Hovudbrytar',
        error: 'Vi klarte ikkje å skru på varslingar akkurat no',
        errorFetchRules: 'Noko gjekk gale ved innhenting av varslingar.',
        errorRetry: 'Prøv igjen',
        errorDeactivate: 'Vi klarte ikkje å skru av varslingar akkurat no',
        errorToggleRule: 'Det har oppstått ein feil, og det er ikkje mogleg å endra varselet akkurat no.',
        chooseNotificationsToGet: 'Vel kva varsel du vil få',
        infoMessage: 'Når du har aktivert pushvarslinger, kan du tilpassa under kva kategoriar du ønskjer å få varslingar om.',
        gdprTitle: 'Personvern',
        gdprDescription: 'Pushvarslingar gir deg beskjed når det hender noko viktig og er helt gratis. Du har full kontroll og kan når som helst skru av varslingane her, under {}.\n' +
            '\n' +
            'For å kunne sende deg pushvarslingar lagrar vi fødselsnummer og kva mobiltelefon du har.\n' +
            'Dette er nødvendig for å kunne nytte seg av tenesta. Opplysningane slettast når du deaktiverar Pushvarslingar.',
        location: 'Profil og innstillingar > Pushvarslingar',
        category: {
            efaktura: 'eFaktura',
            messages: 'Meldingar',
            account: 'Konto',
            loan: 'Lån',
            payments: 'Betaling',
        },
        toggleLabel: {
            EfakturaNotificationRule: 'Ny eFaktura',
            EfakturaWithAvtalegiroNotificationRule: 'Ny eFaktura med Avtalegiro',
            SharedEfakturaAccountNotificationRule: 'Når nokon deler ein eFaktura med deg',
            MessageNotificationRule: 'Melding frå rådgivar',
            SharedAccountNotificationRule: 'Når nokon deler ein konto med deg',
            LoanApplicationNotificationRule: 'Varsel om statusendring i lånesøknaden din',
            OverdueEfakturaNotificationRule: 'Manglande godkjenning av efaktura',
            StoppedPaymentNotificationRule: 'Når ei betaling stoppes',
        },
        accountSpecificNotifications: {
            BALANCE_LESS_THAN: { title: 'Saldo under valgt beløp', text: 'Når saldo på {} går under {}' },
            DEPOSIT_MORE_THAN: {
                title: 'Innbetaling større enn valgt beløp',
                text: 'Når {} får innbetalt beløp over {}',
            },
        },
        salaryLabel: 'Når du får lønn på konto',
        chooseAccountHere: 'Vel konto her',
        account: {
            customNotifications: 'Egendefinerte regler',
            createNotificationRule: 'Opprett ny regel',
            chooseNotificationType: 'Vel ein varseltype',
            chooseAccount: 'Vel konto',
            noAccountsToChooseFrom: 'Ingen mogelege konto',
            youHaveNoMoreAccountsToAddThisNotificationTo: 'Du har ingen fleire konto å legge til denne varseltypen på',
            chooseAmount: 'Sett eit beløp',
            errorCreatingNotification: 'Det har oppstått ein fel, og det er ikkje mogleg å opprette varselet akkurat nå.',
            createNotification: 'Opprett varsel',
            couldNotGetNotificationsForAccount: 'Vi kunne ikkje hente inn varsla for konto',
            amountError: 'Beløpet kan ikkje vere høgare enn: {}',
        },
        deleteFlow: {
            areYouSure: 'Er du sikker på du vil slette dette varselet',
            deleteNotification: 'Slett varsel',
        },
        salary: {
            title: 'Lønn',
            tryingToChangeChosenAccount: 'Forsøkjer å endre valt konto',
            editFailed: 'Endringa feilte',
            accountChanged: 'Konto endra',
            chooseSalaryAccount: 'Vel lønnskonto',
        },
        couldNotGetNotificationsFor: 'Vi kunne ikkje hente inn varsla for {}',
    },
    previous: 'Førre',
    notEnoughInAccount: 'Det er ikkje nok pengar på kontoen',
    new: 'NY',
    next: 'Neste',
    ok: 'OK',
    reserved: 'Reservert',
    expectedBookBalanceDate: 'Forventa oppdatert',
    amountNotAvailableWithDate: 'Denne transaksjonen er reservert på kontoen din, og vil bli gjennomført ved neste bankkøyring. Merk at det kan ta opp til eit døgn før du ser komplette transaksjonsdetaljar',
    receiverTypes: {
        receiver: 'Noreg',
        crossBorderReceiver: 'utlandet',
    },
    receipt: {
        title: 'Kvittering',
        description: 'Du kan få kvittering tilsendt i posten, med eller utan oblat til medlemskort',
        needReceipt: 'Bestill kvittering',
        receiptType: {
            NONE: 'Ingen',
            STICKER: 'Med oblat',
            PRINT: 'Utan oblat',
        },
        receiptTypeVerbose: {
            NONE: 'Ingen kvittering',
            STICKER: 'Kvittering med oblat',
            PRINT: 'Kvittering utan oblat',
        },
        receiptTypeSimplified: {
            NONE: 'Ingen kvittering',
            STICKER: 'Kvittering med oblat',
            PRINT: 'Kvittering',
        },
    },
    recurringPayments: {
        recurringPayment: 'Fast betaling',
        recurringTransfer: 'Fast overføring',
        skipLink: 'Hopp til opprett fast overføring eller betaling',
        recurringPayments: 'Faste betalingar',
        agreements: 'Avtalar',
        noPayments: 'Du har ingen faste betalingar hjå oss',
        errorMessage: 'Orsak, vi klarte ikkje å hente dei faste betalingane dine akkurat no. Prøv igjen om ei tid.',
        createPayment: 'Opprett betaling',
        createTransfer: 'Opprett overføring',
        sureYouWantToDelete: 'Er du sikker på at du vil sletta denne faste {}a?',
        update: 'Oppdater',
        detailsButton: 'Sjå/endre avtalen',
        frequency: 'Frekvens',
        nextDate: 'Neste dato',
        amount: 'Beløp',
        endDate: 'Avsluttes {}',
        cantDeleteMessage: 'Denne betalinga kan ikkje blir her sletta. Kontakt banken for hjelp til å sletta denne fasta {}a',
    },
    recurringPaymentStatus: {
        ACTIVE: 'Aktiv',
        INACTIVE: 'Avslutta',
        UNKNOWN: 'Ukjent',
    },
    recurringPaymentType: {
        PAYMENT: 'betaling',
        TRANSFER: 'overføring',
        UNKNOWN: 'ukjent',
    },
    recurringPaymentValidation: {
        success: 'Fast {} er oppdatert',
        error: {
            heading: 'Oj sann!',
            description: 'Orsak, dette gjekk ikkje heilt etter planen. Sjekk om den faste {}a vart oppdatert før du prøver om att.',
            check: 'Sjekk avtalar',
        },
        notSigned: {
            heading: 'Oj sann!',
            description: 'Endring av fast {} vart ikkje bekrefta, vil du prøve om att?',
            tryAgain: 'Prøv på nytt',
            change: 'Endre',
            cancel: 'Avbryt',
        },
    },
    salaryInfo: {
        title: 'Neste lønn',
        editLink: 'Endre Neste lønn',
        untilNextSalary: 'til neste lønn',
        payments: 'Betalingar',
        left: '{} igjen',
        untilSalary: 'Til lønn',
        daysLeft: ' {} d igjen',
        days: '{} d',
        editSalaryInfoStartPageDescription: 'Usikker på om du har nok pengar til neste lønn? No kan du sjå kor mykje du har igjen på konto fram til neste lønn etter at alle rekningar er betalte.',
        edit: {
            description: '“Neste lønn” er ei berekning av disponibelt beløp minus framtidige betalingar til neste l��nning. Har du innvilga kreditt er den med i berekninga.',
            descriptionGdpr: 'Lønningsdato og vald konto blir lagra så lenge du bruker denne løysinga.',
            confirmDelete: 'Er du sikker på at du vil fjerne “Neste lønn” frå framsida?',
            toFrontpageLink: 'Til framsida',
            updateSuccess: '“Neste lønn” er oppdatert',
            updateError: '“Neste lønn” vart dessverre ikkje oppdatert, ver vennleg og prøv igjen',
            saveSuccess: '“Neste lønn” er lagt til',
            saveError: '“Neste lønn” vart dessverre ikkje lagt til, ver vennleg og prøv igjen',
            deleteSuccess: '“Neste lønn” er fjerna frå framsida',
            deleteError: '“Neste lønn” vart dessverre ikkje fjerna frå framsida, ver vennleg og prøv igjen',
            paydaysError: 'Fyll inn lønningsdato',
            accountError: 'Vel lønningskonto',
            account: {
                placeholder: 'Legg til konto',
                label: 'Konto',
                title: 'Vel konto',
                subtitle: 'Vel kva konto du får lønn på',
            },
            paydays: {
                placeholder: 'Legg til lønningsdato',
                label: 'Lønningsdato',
                title: 'Legg til lønningsdato',
                subtitle: 'Vel ein eller fleire datoar',
                lastDay: 'siste dag',
                lastDayOfMonth: 'Siste dag kvar månad',
                eachMonth: 'Den {} kvar månad',
                the: 'Den ',
                and: ' og',
            },
        },
    },
    save: 'Lagre',
    seeAllAccounts: 'Sjå alle kontoar',
    settingsAccountOrderNeedMoreAccounts: 'Du må ha fleire kontoar hos oss for å endre visning og rekkefølge på kontoer',
    settingsAccountFavoriteNeedMoreAccounts: 'For å endre favorittkonto må du ha fleire kontoar',
    to: 'Til',
    settings: {
        pushNotifications: 'Pushvarslingar',
        changeAppIcon: 'Appikon',
        login: 'Innlogging og sikkerhet',
        paymentSettings: 'Betalingsinnstillingar',
        paymentSettingsSubtitle: 'eFaktura, AvtaleGiro og beløpsgrenser',
        nextSalary: 'Neste lønn',
        nextSalarySubtitle: 'Sjå kva du har igjen etter at alle rekningar er betalte',
        aboutApp: 'Om bruk av banken',
        myConsents: 'Samtykker',
        minBolig: 'Min bustad',
        price: 'Prisar',
        meMyselfAndI: 'Meg og mitt',
        adaptations: 'Tilpassingar',
        account: 'Konto',
        accountDescription: 'Vel favorittkonto og rekkjefølgje på kontoar',
        contactInfo: 'Kontaktinfo og legitimering',
        contactInfoBM: 'Bedriftens kontaktinfo',
        language: 'Språk',
        becomeCustomerChild: 'Kundeetablering for barn',
        moveSalary: 'Flytt lønnskonto',
        appearance: 'Utsjånad',
    },
    thirdPartyDependencies: {
        title: 'Våre tredjepartslisensar',
        description: 'Her er ei samling av alle relevante lisensar vi nyttar oss av i mobilbanken.',
    },
    invalidFromAccount: {
        transferNotPossible: 'Denne kontoen kan du ikkje overføre ifrå',
        paymentNotPossible: 'Denne kontoen kan du ikkje betala ifra',
        transferBecauseItIs: 'fordi det er ein',
        chooseAnotherAccountTransfer: 'Alt håp er ikkje ute, vel ein annan konto for å overføre',
        chooseAnotherAccountPayment: 'Alt håp er ikkje ute, vel ein annan konto for å betale',
    },
    invalidToAccount: 'Ugyldig kontonummer: {}',
    missingToAccountTransfer: {
        title: 'For å overføra pengar må du ha minst to ulike kontoar som du kan overføra pengar mellom.',
        tip: 'Tips!',
        description: 'Klikk på “Betal” om du skal senda pengar til nokon andre.',
        buttonText: 'Betal til nokon andre',
    },
    tooManyCharacters: 'Du kan ikkje ha meir enn {} teikn i meldinga.',
    tooManyCharactersKID: 'Du kan ikkje ha meir enn {} siffer i KID-feltet for denne mottakeren.',
    transfer: 'Overfør',
    transferAmount: 'Overfør beløp',
    transferFromAccount: 'Frå konto',
    transferToAccount: 'Til konto',
    tryAgain: 'Prøv om att',
    transactionListNoTransactionsTitle: 'Her har det ikkje skjedd stort!',
    transactionListNoMoreTransactionsToLoadTitle: 'Dette var alle transaksjonar de siste 12 månadane',
    transactionListCouldNotGetTransactions: 'Orsak, vi kunne ikkje hente transaksjonane dine grunna teknisk svikt',
    transactionListCouldNotLoadMoreTransactions: 'Orsak, grunna teknisk svikt klarte vi ikkje å laste fleire transaksjonar. Prøv igjen om ei tid.',
    transactionSuccessPushNudge: {
        title: 'Få pushvarsling neste gong du får ein eFaktura',
        description: 'Pushvarslinger gjer det enklare å halda seg oppdatert på endringar og ting du må ta stilling til i mobilbanken',
        buttonText: 'Gå til Pushvarslinger',
        abortButtonText: 'Ikkje no',
    },
    viewEFaktura: 'Sjå eFaktura',
    continue: 'Hald fram',
    accountNumber: 'Kontonummer',
    accountName: 'Kontonamn',
    accountOwners: 'Kontoeigarar',
    paymentItem: {
        title: 'Betaling',
        sureYouWantToUnapprove: 'Er du sikker på at du vil fjerne godkjenninga di fra denne betalinga?',
        sureYouWantToDelete: 'Er du sikker på at du vil sletta denne betalinga?',
        isDeleted: 'Betalinga vart sletta',
        restartSuccess: 'Betalinga vart fullført',
    },
    paymentFrom: 'Betale frå',
    payAmount: 'Beløp',
    payFromAccount: 'Betal frå konto',
    paymentFromAccountName: 'Legg til namn eller bedrift',
    paymentAddOwnText: 'Eigen tekst på betalinga',
    transferAddOwnText: 'Eigen tekst på overføringa',
    ownTextPlaceholder: 'Skriv eigen tekst her',
    paymentAddOwnTransactionText: 'Eigen tekst på betalinga',
    kidHelpWithDash: {
        canHelp: 'Vi ser at denne KID-en bør innehalda ein bindestrek - skal vi leggja til ein for deg?',
        addDash: 'Legg til bindestrek',
        gotHelp: 'Bindestrek lagt til! Du kan trygt halda fram betalinga.',
    },
    accountView: {
        noAccount: 'Fann ikkje konto',
        disposible: 'Disponibelt',
        creditUnused: 'Du har i tillegg {} i kreditt på denne kontoen',
        creditUsed: '{} tilgjengeleg av {} i kreditt',
    },
    receiverSearch: 'Namn eller kontonummer',
    receiverIsAdded: 'Mottakaren er lagt til',
    receiverIsDeleted: 'Mottakaren er sletta',
    receiverIsUpdated: 'Mottakaren er endra',
    receiversNotFound: 'Ingen treff i mottakarlista',
    search: 'Søk',
    name: 'Namn',
    addNewReceiver: 'Legg til ny mottakar',
    addReceiver: 'Legg til mottakar',
    confirmDeleteReceiver: 'Er du sikker på at du vil sletta denne mottakaren?',
    paymentValidation: {
        invalidAccountNumber: 'Her er det noko feil. Sjekk om du har riktig kontonummer',
        requiredField: 'Dette feltet er påkravd',
        existingAccountNumber: 'Åtvaring! Denne mottakaren eksisterer allereie i mottakarlista som {}',
        chooseFromAccount: 'Ver vennleg og vel frå konto',
        chooseToAccount: 'Du må velja konto',
        receiverDontAcceptImmediatePayment: 'Denne mottakaren kan ikkje motta straksbetaling',
        receiverDoesNotSupportImmediatePayment: 'Mottakaren støttar ikkje straksbetalingar',
        chooseAmount: 'Du må skriva inn beløp',
        chooseValidDate: 'Dato må vera i dag eller seinare',
        noCoverage: 'Det er ikkje nok pengar på konto',
        invalidKID: 'Vi kjenner ikkje igjen KID-nummeret. Sjekk at alle tal er riktige og forsøk om att',
        missingKID: 'Legg til KID-nummer',
        missingNote: 'Legg til melding',
        amountLowerThanMinimum: 'Minimum å betala {}',
        amountExceedsMaximum: 'Maksgrense for ei betaling er {} kr',
        amountExceedsMonthlyMaximum: 'Beløpet vil gå over månadleg betalingsgrense på {} kr',
    },
    minAmountToPay: 'Minimum å betala {}',
    transactions: 'Transaksjonar',
    history: 'Historikk',
    transactionDetails: {
        from: 'Frå',
        to: 'Til',
        date: 'Dato',
        bookingDate: 'Bokført',
        message: 'Melding',
        ownMessage: 'Eige tekst',
        purpose: 'Beskjed',
        category: 'Kategori',
        errorMessage: 'Orsak, vi kunne ikkje hente transaksjonsdetaljane dine grunna teknisk svikt',
        receiver: {
            address: 'Mottakars adresse',
            bank: 'Mottakars bank',
            bicOrSwift: 'BIC/SWIFT',
        },
        bankReferenceNumber: 'Bankens arkivreferanse',
        kid: 'KID-nummer',
        download: 'Last ned som PDF',
        approvers: {
            createdBy: 'Oppretta av',
            approvedBy: 'Godkjent av',
        },
        singleApprover: 'Betalt av',
        infoWillCome: 'Informasjon kjem',
        multipleTransactionsDetails: 'Sjå meir i nettbank',
    },
    transactionTypes: {
        PAYMENT: 'Betaling',
        TRANSFER: 'Overføring',
        RESERVATION: 'Reservasjon',
        AUTOPAYMENT: 'AvtaleGiro',
        AUTOPAYMENTWITHINVOICE: 'AvtaleGiro med eFaktura',
        EFAKTURA: 'eFaktura',
        IMMEDIATE: 'Straksbetaling',
        INTEREST: 'Renter',
        FEE: 'Gebyr',
        CARD: 'Kortbetaling',
        WITHDRAWL: 'Uttak',
        INTERNATIONAL: 'Utanlandsbetaling',
        UNKNOWN: 'Ukjent',
        PAYMENT_OR_TRANSFER: 'Betaling eller overføring',
        SALARY: 'Lønn',
        INBOUND: 'Innbetaling',
        COMBINED_POSTING: 'Samlebetaling',
        VIPPS: 'Vipps',
        CASH: 'Kontantuttak',
    },
    transactionStatus: {
        BOOKED: '',
        RESERVED: 'Reservert',
        CONFIRMATION: 'På vei',
    },
    transactionCategories: {
        INCOMING: 'Pengar inn',
        OUTGOING: 'Pengar ut',
        PAYMENT: 'Betaling',
        TRANSFER: 'Overføring',
        INTERNATIONAL: 'Utanlandsbetaling',
        PURCHASE: 'Varekjøp',
        SALARY: 'Lønn',
        INTEREST: 'Renter',
        CHARGE: 'Kostnader',
        OTHER: 'Anna',
    },
    transactionFilter: {
        filterTransactions: 'Søk og filtrer i transaksjonar',
        search: 'Søk',
        freetextPlaceholder: 'Søk etter transaksjonar',
        chooseCategory: 'Kategori',
        chooseAmount: 'Vel beløp',
        from: 'Fra',
        to: 'Til',
        choosePeriod: 'Vel periode',
        fromDateError: {
            invalid: 'Oppgje ein gyldig fra-dato',
            required: 'Oppgje ein gyldig fra-dato',
            outOfRangeMax: 'Oppgje ein fra-dato som ikke er i framtida',
            outOfRangeMin: 'Datoen du har valt er for langt tilbake i tid',
        },
        toDateError: {
            invalid: 'Oppgje ein gyldig til-dato',
            required: 'Oppgje ein gyldig til-dato',
            outOfRangeMax: 'Oppgje ein til-dato som ikkke er i framtida',
            outOfRangeMin: 'Datoen du har valt er for langt tilbake i tid',
        },
        showHits: 'Vis treff',
        cancel: 'Avbryt',
        resetFilter: 'Nullstill filter',
        remove: 'Fjern filter: {}',
        editFilter: 'Endre filter: {}',
        openModal: 'Åpne filtreringsvindu',
        activeFilters: 'Aktive filtre',
        noMoreToLoad: 'Det var alle transaksjonane for søket ditt på denne kontoen',
        noHits: 'Fann ingen transaksjonar med det søket',
        reservedTransactionMessage: 'Viser ikkje reserverte transaksjonar',
        choose: 'Vel',
        period: 'Periode',
        amount: 'Beløp',
        sentDirection: 'Penger sendt',
        receivedDirection: 'Penger mottatt',
        sent: 'sendt',
        received: 'mottatt',
        lastMonths: 'Siste {} månader',
        lastMonth: 'Siste månad',
        goToAdvancedSearch: 'Gå til avansert søk ',
        toTheTop: 'Til toppen',
        didYouNotFindWhatYouWereLookingFor: 'Finnar du ikkje det du leiter etter?',
        backToSearch: 'Tilbake til søk',
        removeChosen: 'Fjern val',
    },
    transactionDownload: {
        open: 'Åpne',
        close: 'Lukk',
        downloadMenu: '{} nedlastningsmeny',
        exportToPdf: 'Last ned som PDF',
        exportToExcel: 'Eksporter til Excel',
        exportToCSV: 'Eksporter til CSV',
        error: 'Nedlastinga feila',
    },
    update: 'Oppdater',
    signing: {
        title: 'Signering av betaling',
    },
    clientError: {
        TIMEOUT: {
            title: 'Noko gjekk gale.',
            description: 'Orsak, dette tok noko lengre tid enn vi hadde tenkt. Du må gjerne prøve om att',
        },
        INVALID_KID: {
            title: 'Angitt KID er ikkje gyldig.',
            description: 'Prøv igjen eller utfør betalinga utan KID.',
        },
        ACCOUNT_BLOCKED_TO_RECEIVE_TRANSACTIONS: {
            title: 'Betalinga vart ikkje fullført.',
            description: 'Det er ikkje lengre mogleg å betale til denne kontoen',
        },
        BANK_DISABLED: {
            title: 'Banken ikkje tilgjengeleg',
            description: 'Ver vennleg og prøv igjen seinare',
        },
        DUPLICATE_AVTALEGIRO_AGREEMENT: {
            title: 'Din AvtaleGiro vart ikkje oppretta',
            description: 'Det ser ut som det er ein annan AvtaleGiro med same KID nummer på denne mottakaren. Sjekk om opplysningane stemmer.',
        },
        DIRECT_DEBIT_AGREEMENT_EXISTS_IN_OTHER_BANK: {
            title: 'Din AvtaleGiro vart ikkje oppretta',
            description: 'Det ser ut som du allereie har denne Avtalegiroen i ein annan bank. Benytt `Hent AvtaleGiro` for å flytta han.',
        },
        DIRECT_DEBIT_CLIENT_DOES_NOT_HAVE_ACCESS: {
            title: 'Du har ikkje tilgang til denne funksjonen',
            description: 'Det er berre administrator i avtalen som kan sjå og endre AvtaleGiro-avtalar',
        },
        CREDIT_ACCOUNT_BLOCKED: {
            title: 'Kontoen du prøver å betala til er blokkert',
            description: 'Det ser ut som ein ikkje kan senda pengar til denne mottakaren.',
        },
        DUE_DATE_CANNOT_BE_IN_THE_PAST: {
            title: 'Betalingsdato kan ikkje vere i fortida',
            description: 'Du må velja ein dato I framtida for gå vidare',
        },
        INVALID_CREDITOR_ACCOUNT_NUMBER: {
            title: 'Mottakars kontonummer er fel',
            description: 'Sjekk kontonummeret eller vel eit anna kontonummer',
        },
        CREDITOR_ACCOUNT_IS_CLOSED: {
            title: 'Mottakars konto er avslutta',
            description: 'Du kan ikkje betala til dette kontonummeret fordi det er avslutta. Vel eit anna kontonummer for å halda fram.',
        },
        ACCOUNT_NOT_FOUND: {
            title: 'Denne kontoen finst ikkje',
            description: 'Denne kontoen finst ikkje',
        },
        INACTIVE_CUSTOMER: {
            title: 'Noko gjekk gale!',
            description: 'Ingen tilgang på grunn av brukarstatus.',
        },
        KUNDE_MANGLER: {
            title: 'Noko gjekk gale!',
            description: 'Kunne ikkje finna deg som kunde hos oss.',
        },
        DISPLAY_NAME_UPDATE_FAILED: {
            title: 'Noko gjekk gale!',
            description: 'Vi kunne ikkje oppdatera kontonamnet.',
        },
        MAX_TRANSACTION_AMOUNT_EXCEEDED: {
            title: 'Overføringa kan ikkje gjennomførast',
            description: 'Du har overskride det årlege sparebeløpet for denne kontoen',
        },
        INGEN_DEKNING: {
            title: 'Overføringa kan ikkje gjennomførast',
            description: 'Det var ikkje dekning for beløpet som vart freista overført',
        },
        MANGLER_AVTALE: {
            title: 'Noko gjekk gale!',
            description: 'Du har ikkje tilgang til eFaktura på avtalen din',
        },
        AVTALEGIRO_NOT_FOUND: {
            title: 'Noko gjekk gale!',
            description: 'Vi kunne ikkje finna AvtaleGiroen',
        },
        LOAN_CALCULATION_ERROR: {
            title: 'Problem ved rekning av nedbetalingsplan',
            description: 'Kontakt oss så kan vi fikse problemet',
        },
        REPAYMENT_PLAN_UPDATE_FAILED: {
            title: 'Nedbetalingsplan kunne ikkje oppdaterast',
            description: 'Kontakt oss så kan vi fikse problemet',
        },
        EXCEEDED_ACCUMULATED_TRANSACTION_AMOUNT: {
            title: 'Vi klarte ikkje utføra betalinga.',
            description: 'Angitt beløp er større enn beløpsgrensa pr månad.',
        },
        CIRCUIT_BREAKER_OPEN: {
            title: 'Noko gjekk gale!',
            description: 'Orsak, det oppstod ein teknisk feil. Ver vennleg og prøv igjen om ei tid.',
        },
        LOAN_ARREAR_ERROR: {
            title: 'Endring av lån ikkje mogleg',
            description: 'Vi kunne ikkje gjennomføra endring på lånet på grunn av uteståande betaling',
        },
        SUSPECTED_FRAUD_RECIPIENT: {
            title: 'Mistenkjeleg mottakar',
            description: 'På grunn av mistanke om svindel, kan vi ikkje gjennomføra betalinga. Kontakt banken om du meiner dette er feil.',
        },
        AMOUNT_GREATER_THAN_MAX_TRANSACTION_LIMIT: {
            title: 'Vi klarte ikkje utføra betalinga.',
            description: 'Angitt beløp er større enn beløpsgrensa.',
        },
        LACK_OF_FUNDS: {
            title: 'Betalingen vart ikkje gjennomført!',
            description: 'Det var ikkje dekning for beløpet som vart prøvd betalt',
        },
        NO_ACTIVE_AGREEMENTS: {
            title: 'Kunne ikkje endre eFaktura-avtale',
            description: 'Vi fann ingen aktiv avtale, ta kontakt dersom det held fram',
        },
        NOT_AUTHORIZED_FOR_OPERATION: {
            title: 'Kunne ikkje gjennomføra betalinga',
            description: 'Du har ikkje tilgang til å gjera denne operasjonen',
        },
        BSU_ACCOUNT_LIMIT_REACHED: {
            title: 'Kunne ikkje betala inn på BSU konto',
            description: 'BSU kontoen har nådd maks-beløpet',
        },
        NO_ACCESS_TO_ACCOUNT: {
            title: 'Kunne ikkje vise kontoinformasjon',
            description: 'Du har ikkje tilgang til denne kontoen',
        },
        UNKNOW_CREDITOR: {
            title: 'Mottakaren støttar ikkje AvtaleGiro',
            description: 'Verifiser at kontonummer er rett',
        },
        PRODUCT_ORDER_FAILED: {
            title: 'Noko gjekk gale!',
            description: 'Vi kunne ikkje oppretta kontoen.',
        },
        BATCH_APPROVE_EFAKTURA_FAILED: {
            title: 'Noko gjekk gale!',
            description: 'Vi kunne ikkje godkjenna eFakturaene.',
        },
        ACCOUNT_CLOSE_FAILED_RECURRING_PAYMENT: {
            title: 'Noko gjekk gale!',
            description: 'Vi kunne ikkje avslutta kontoen fordi det er aktive faste betalingar.',
        },
        OCR_VALIDATION_FAILED: {
            title: 'KID validering feila',
            description: 'Sjekk at KID er skriven inn korrekt.',
        },
        UGYLDIG_TRANSACTION_ID: {
            title: 'Noko gjekk gale!',
            description: 'Vi kunne ikkje henta transaksjonen.',
        },
        PAYMENT_NOT_FOUND: {
            title: 'Noko gjekk gale!',
            description: 'Vi kunne ikkje finna betalinga.',
        },
        MESSAGE_TOO_LONG: {
            title: 'Meldinga er for lang',
            description: 'Kunne ikkje gjennomføra betalinga fordi meldinga er for lang.',
        },
        INVALID_IBAN: {
            title: 'Ugyldig IBAN',
            description: 'Sjekk at IBAN er skriven inn korrekt.',
        },
        PAYMENT_VALIDATION_ERROR: {
            title: 'Betalinga kunne ikkje gjennomførast',
            description: 'Verifiser at beløsgrenser ikkje er overgått',
        },
    },
    dateField: {
        diffTimeZoneMessage: 'Vi forheld oss til tidssona i Noreg, viss du er i eit land i ei anna tidssone er det viktig å berekna tid etter dette.',
        bankHolidayMessage: 'Vêr merksam på at betalinga gjennomførast fyrste kvardag etter vald dato.',
        title: 'Vel dato',
        today: 'I dag',
        paymentInterval: {
            titlePayment: 'Betalinga skal gjentakast',
            titleTransfer: 'Overføringa skal gjentakast',
            titleEnd: 'Avtalen avsluttes',
            alias: 'Vert gjenteken',
            lastPaymentDate: 'Avsluttes',
            noLastPaymentDate: 'Aldri',
            withEndDate: ' til {} ',
        },
        recurringPaymentInterval: {
            DAILY: 'Dagleg',
            WEEKLY: 'Vekentlig',
            EVERY_TWO_WEEKS: 'Annankvar veke',
            MONTHLY: 'Månadleg',
            EVERY_TWO_MONTHS: 'Annankvar månad',
            QUARTERLY: 'Kvartalsvis',
            EVERY_FOUR_MONTHS: 'Kvar fjerde månad',
            SEMIYEARLY: 'Kvart halvår',
            YEARLY: 'Årleg',
            UNKNOWN: 'Ukjend',
        },
        recurringPaymentDateInterval: {
            DAILY: ' og dagleg',
            WEEKLY: ' og vekentlig',
            EVERY_TWO_WEEKS: ' og annankvar veke',
            EVERY_TWO_MONTHS: ' og annankvar månad',
            QUARTERLY: ' og kvartalsvis',
            EVERY_FOUR_MONTHS: ' og kvar fjerde månad',
            SEMIYEARLY: ' og kvart halvår',
            MONTHLY: ' og månadleg',
            YEARLY: ' og årleg',
            UNKNOWN: '',
        },
        endDates: {
            NEVER: 'Aldri',
            TO_END_OF_YEAR: 'Ut året',
            IN_3_MONTHS: 'Om 3 månader',
            IN_6_MONHTS: 'Om 6 månader',
            IN_12_MONTHS: 'Om 12 månader',
            CUSTOM: 'Vel eigen dato',
        },
    },
    receiverNameOverride: 'Du har lagra dette kontonummeret som {}.',
    toggleKid: 'Byt til KID',
    toggleNote: 'Byt til melding',
    amountNote: {
        [NoteTypes.MESSAGE]: {
            label: 'Melding',
            placeholder: 'Legg til melding',
        },
        [NoteTypes.KID]: {
            label: 'KID',
            placeholder: 'Legg til KID',
        },
        [NoteTypes.KID_OR_MESSAGE]: {
            label: 'KID/Melding',
            placeholder: 'Legg til KID eller melding',
        },
    },
    payTo: 'Betal til',
    chooseAccount: 'Vel konto',
    favoriteAccount: {
        favoriteAccountCardTitle: 'Vel ein favorittkonto',
        favoriteAccountCardButtonText: 'Legg til favorittkonto',
        favoriteAccountCardDescription: 'Med ein favorittkonto blir det endå enklare å betala og overføra.',
        favoriteAccountModalTitle: 'Vel favorittkonto',
        favoriteAccountModalDescription: 'Du kan når som helst endra favorittkonto om du vil byta til ein annan konto.',
        saveFavoriteAccountButtonText: 'Lagra',
        favoriteAccountSaved: 'Favorittkonto er valgt',
        frontpageFavoriteAccountButtonText: 'Kom i gong',
        frontpageFavoriteAccountModalText: 'Med ein favorittkonto blir betaling og overføring endå enklare.',
    },
    dismissKeyboard: 'Ferdig',
    accountDetails: {
        seeDetails: 'Sjå kontodetaljar',
        moreInfoAboutThisAccount: 'Meir informasjon om kontoen din',
        seeAccountDetails: 'Sjå kontodetaljar',
        copyAccountNumber: 'Kopier kontonummer',
        copyIBAN: 'Kopier IBAN',
        cardsConnectedToTheAccount: 'Kort knytta til kontoen',
        card: 'Bankkort',
        accountName: 'Kontonamn',
        accountProductName: 'Produktnamn',
        accountDetailsErrorMessage: 'Orsak, vi kunne ikkje hente kontodetaljane dine grunna teknisk svikt',
        mainOwner: 'Hovudeigar',
        owner: 'Eigar',
        accountAccess: 'Kontotilgangar',
        addAuthorizedCustomer: {
            responsibility: 'Det er ditt ansvar som kontohaver å informera disponenten om punkta under.',
            shareAccount: 'Del konto',
            chooseWho: 'Kven ynskjer du å dele med?',
            mustBeCustomer: 'Hugs at personen må vere kunde i banken.',
            mustBeCustomerWarning: 'Personen må vere kunde i banken',
            confirmText: 'Du gir {} tilgang til "{}" med kontonummer {}',
            ssid: 'Skriv fødselsnummer',
            ssidError: 'Sjekk at du har skrive riktig fødselsnummer',
            fillName: 'Skriv fullt namn',
            fullname: 'Fullt namn',
            nameError: 'Namnet må samsvare med fødselsnummeret',
            elevenCharacters: '11 siffer',
            nextButton: 'Neste',
            backButton: 'Tilbake',
            shareAccountButton: 'Del konto no',
            shareSuccess: 'Kontoen er delt!',
            doneButton: 'Ferdig',
            deleteConfirmationQuestion: 'Er du sikker på at du vil fjerne {} som disponent av kontoen?',
            deleteConfirmationButton: 'Ja, jeg er sikker',
            deleteCancelButton: 'Avbryt',
            deleteConfirmation: '{} er ikkje lenger disponent av denne kontoen.',
            confirmTitle: 'Kort oppsummert',
            termsTitle: 'Vilkår',
            termsSharingAccountInfo: 'Den du delar konto med kan:',
            termsSharingAccountInfoList: {
                itemOne: 'gjera uttak av kontantar',
                itemTwo: 'gjennomføra betalingar frå konto',
                itemThree: 'sjå kontoforholdet',
                itemFour: 'disponera konto i disponenten sin eigen nettbank eller mobilbank',
                itemFive: 'sjå all transaksjonshistorikk på kontoen',
            },
            termsIncludingInfo: 'Dette inneber blant anna at:',
            termsIncludingInfoList: {
                itemOne: 'Beløpsgrense for disposisjonsretten følgjer den beløpsgrensa som gjeld for disponentens digitalbank',
                itemTwo: 'Disponenten kan inngå avtale om AvtaleGiro på vegner av kontohavar',
                itemThree: 'Disponenten skal bruka sin eigen personlege tryggingsinformasjon og sin eigen BankID, ikkje kontohavars',
            },
            deleteAuthorizedCustomer: 'Fjern disponent',
        },
        details: 'Detaljar',
        openedDate: 'Opningsdato',
        iban: 'IBAN',
        bic: 'BIC/SWIFT',
        sepaBic: 'BIC/SWIFT frå EU/EØS + Sveits + Storbritannia',
        routingBic: 'BIC/SWIFT alle andre land',
        couldNotSave: 'Orsak, endringane vart ikkje lagra. Prøv igjen om ei tid.',
        maxCharacters: 'Du kan ha maks {} teikn',
        accountType: 'Kontotype',
        mappedAccountType: {
            BSU: 'BSU',
            BSU_PLUSS: 'BSU Pluss',
            CLIENT_ACCOUNT: 'Klientkonto',
            CURRENCY_ACCOUNT: 'Valutakonto',
            CURRENCY_LOAN: 'Valutalån',
            ESTATECREDIT: 'Flexilån',
            GUARANTEE: 'Garanti',
            LOAN: 'Lån',
            RDS: 'RDS',
            SAVING: 'Sparekonto',
            SPENDING: 'Brukskonto',
            STOCKSAVINGS: 'Aksjesparekonto',
            SURETY: 'Kausjon',
            TAXWITHDRAW: 'Skattetrekkskonto',
            FLEXILOAN: 'Flexilån',
            UNKNOWN: 'Ukjent',
        },
        orgContact: 'Kontakt oss',
    },
    accountsList: {
        errorMessage: 'Noko gjekk gale ved henting av kontoane dine',
        noAccountsHeader: 'Du har ingen kontoar',
        noAccountsDescription: 'Kontakt oss gjerne så hjelper vi deg i gang.',
        noAccountsDescriptionWithButton: 'Trykk på lenka under for å gå til skjema for oppretting av kontoar, eller ta kontakt med oss så hjelper vi deg i gang.',
        createAccount: 'Ny konto',
        createNewAccount: 'Opprett ny konto',
        infoOnAccounts: 'Opne ein ny sparekonto eller brukskonto',
        totalBalance: 'Totalt',
        clauseWithoutForeignCurrency: 'Valutakontoar er ikkje med i berekninga',
        emptyAccountsGroup: 'Flytta kontoar hit for å oppretta ei ny gruppe',
    },
    accountInterest: {
        header: 'Renter',
        types: {
            [InterestType.CREDIT]: {
                interest: 'Kredittrente',
                above: 'Kredittrente over',
                upTo: 'Kredittrente opptil',
            },
            [InterestType.DEBIT]: {
                interest: 'Innskuddsrente',
                above: 'Innskuddsrente over',
                upTo: 'Innskuddsrente opptil',
            },
        },
        overdraftInterest: 'Overtrekksrente',
        grantedOverdraftInterest: 'Bevilget overtrekksrente',
        notYetCapitalizedInterest: 'Renter beregnet, ikkje bokført',
    },
    invoiceArchive: {
        noInvoices: 'Ingen eFaktura',
        status: {
            PAID: 'Godkjent',
            NEW: 'Ny',
            UNPAID: 'Ubetalt',
            DELETED: 'Slettet',
            APPROVED: 'Godkjent',
            HAS_AVTALEGIRO: 'AvtaleGiro',
            UNKNOWN: 'Ukjent',
        },
    },
    profile: {
        myProfile: 'Min profil',
        messages: 'Meldingar',
        letters: 'Dokument',
        switchBank: 'Vel bank',
        switchBankAndAgreement: 'Vel bank eller avtale',
        switchAgreement: 'Vel avtale',
        unreadMessagesSingle: 'du har {} ulesen melding',
        unreadMessagesplural: 'du har {} ulesne meldingar',
        agreementError: 'Vi klarte dessverre ikkje å henta avtalane dine akkurat no. Prøv om att om litt, eller kontakt banken om problemet held fram.',
    },
    switchBankOrAgreement: {
        toggleAgreementPM: 'Byt til Privat',
        toggleAgreementBM: 'Byt til Bedrift',
        toggleBankOrAgreement: 'Byt bank eller avtale',
        toggleBank: 'Byt bank',
    },
    periodicControl: {
        intro: 'Det er viktig at vi har rett kontaktinfo på deg, sånn at vi kan informera deg om viktige ting relatert til kundeforholdet ditt',
        correctContactInfo: 'Stemmer informasjonen vi har om deg?',
        noEdit: 'Nei, endre',
        yesCorrect: 'Ja, det stemmer',
        thanks: 'Takk for hjelpa',
        howToEdit: 'Dersom du treng å gjere fleire endringar av kontaktinformasjon, kan du gjere det under menypunktet Profil og Innstillingar',
        backToMobileBank: 'Til mobilbanken',
        backToNettbank: 'Til nettbanken',
        error: 'Ojda!',
        errorTitle: 'Noko gjekk gale!',
        cancel: 'Avbryt',
    },
    contactInfo: {
        editContactInfo: 'Endre kontaktinformasjon',
        contactInfo: 'Din kontaktinformasjon',
        email: 'E-post',
        mobile: 'Mobilnummer',
        address: 'Adresse',
        emailMissing: 'Inga registrert e-postadresse',
        mobileMissing: 'Inga registrerte telefonnummer',
        addressMissing: 'Inga registrert adresse',
        save: 'Lagre',
        success: 'Kontaktinformasjon vart oppdatert',
        messages: 'Gå til meldingar',
        signingError: {
            contactMessage: 'Hvis feilen vedvarer, ta kontakt med oss.',
            message: 'Signeringa feila! Det kan vere at epostadressa eller mobilnummeret ikkje var gyldig. Sjekk om du har skrive de riktig, og prøv om att.',
        },
        stepUp: {
            text: 'Vi er nøydde til å forsikra oss om at ingen prøver å gje seg ut for å vera deg. Gjennom ei enkel biletverifisering får du igjen tilgang til endring av telefonnummer.',
            link: 'Kom i gang',
        },
        warnings: {
            email: 'For å forandre epost-en må du sende oss ei melding.',
            mobile: 'For å forandre mobilnummeret må du sende oss ei melding.',
            mobileDesktop: 'Endring av mobilnummer kan gjerast i mobilbanken eller ved å sende oss ei melding.',
            address: 'Endring av adresse må gjerast i folkeregisteret',
        },
        errors: {
            foundNoInfo: 'Fant ingen kontaktinformasjon',
            wrongEmailFormat: 'E-post må skrivast i riktig format, til dømes “navn@epost.no”',
            wrongMobileFormat: 'Feil format på telefonnummeret',
        },
    },
    companyInfo: {
        generalManagerNotFound: 'Fann ikkje dagleg leiar!',
        editCompanyInfo: 'Informasjon om dagleg leiar',
        editDescription: 'Her kan du registrere eller endra telefonnummer og e-postadresse for deg som dagleg leiar. Vær merksam på at denne informasjonen blir relatert til di rolle i bedrifta, og ikkje som privatperson.',
        editNameWarning: 'Endring av namn må gjerast gjennom brønnøysundregisteret',
        companyInformation: 'Bedriftsinformasjon',
        companyName: 'Namn på bedrift',
        organisationNumber: 'Organisasjonsnummer',
        address: 'Adresse',
        generalManager: 'Dagleg leiar',
        editGeneralManager: 'Endre kontaktinfo for dagleg leiar',
        cannotEditGeneralManager: 'Det er berre den registrerte dagleg leiar som har mogelegheit til å endra kontaktinfo om dagleg leiar',
        updateSuccess: 'Dagleg leiar oppdatert',
        errors: {
            invalidEmail: 'E-post må skrivast i riktig format, til dømes “navn@epost.no”',
            invalidMobile: 'Feil format på telefonnummeret',
        },
    },
    updatePaymentLimits: {
        validation: {
            cannotExceedMonthly: 'Betalingsgrensa for ei betaling kan ikkje vera større enn betalingsgrensa for ein månad.',
            bankRestricted: 'Maksgrense for ei betaling kan ikkje vera høgare enn {} kr',
            bankRestrictedMonthly: 'Maksgrense for ein månad kan ikkje vera høgare enn {} kr',
            fillInField: 'Fyll inn feltet',
        },
        result: {
            rejectedTitle: 'Oj sann!',
            rejectedInfo: 'Vi beklagar dette gjekk ikkje helt etter planen. Sjekk om betalingsgrensene vart oppdatert før du prøver om att.',
            check: 'Sjekk betalingsgrenser',
            success: 'Betalingsgrenser er oppdatert',
            close: 'Lukk',
            toFrontPage: 'Til framsida',
        },
        missingRights: 'Du har ikkje rettar til å endra betalingsgrenser',
        maxTransactionAmount: 'Maksgrense for ei betaling',
        maxMonthlyTransactionAmount: 'Maksgrense for ein månad',
        update: 'Endre maksgrense',
        stepUpRequired: {
            title: 'Auka tryggleik',
            text: 'Endring av beløp krev høg tryggleik. For å gjera dette må du verifisera deg. Det går raskt, og når du er ferdig opnar vi samtidig opp meir funksjonalitet for deg i mobilbanken.',
            text2: 'Det er lett og tek berre eit par minutt.',
            stepUpButton: 'Kom i gang',
        },
        mobileRiskyDevice: {
            title: 'Auka tryggleik',
            text: 'Endring av beløp krev høg tryggleik. For å gjera dette må du kontakta oss direkte.',
            text2: 'Det kan du gjera her',
            buttonText: 'Ring oss',
        },
        desktopRiskyDevice: {
            title: 'Auka tryggleik',
            text: 'Endring av beløp krev høg tryggleik. Derfor må dette gjennomførast i mobilbanken.',
            text2: 'Har du ikkje mobilbank tilgjengeleg, kan du kontakta oss direkte.',
        },
        currentlyYouHavePaid: 'Hittil har du betalt {}',
    },
    closeWindow: 'Lukk vindu',
    withdrawals: {
        infoAboutNumberOfWithdrawalsLeft: 'Du har {} gebyrfrie uttak igjen {} frå denne kontoen.',
        oneWithdrawalLeft: 'Du har 1 gebyrfritt uttak igjen {} frå denne kontoen.',
        noWithdrawalsLeft: "Du har ikkje fleire gebyrfrie uttak i år. Alle uttak frå kontoen vil ha eit gebyr i henhold til prislistene våre.',",
        freeWithdrawals: 'Gebyrfrie uttak igjen',
        freeWithdrawalsOf: '{} av {}',
        withdrawalPeriods: {
            ANNUALLY: 'i år',
            BI_ANNUALLY: 'denne to-årsperioden',
            MONTHLY: 'denne månaden',
            QUARTERLY: 'dette kvartalet',
            SECOND_MONTH: 'denne to-månadsperioden',
            TERTIALY: 'denne tredjedelen av året',
            UKNOWN: 'denne perioden',
        },
    },
    openPaymentWindow: 'Opne betalings- og overføringsvindauge',
    documentsForSigning: 'Oppgåver til gjennomgang',
    kredittbanken: {
        category: {
            ANSWER_KYC: 'Fyll ut kundeerklæring',
            APPLICATION: '',
            UNKNOWN: '',
        },
        kycInfo: 'Du må fylla ut kundeerklæring slik at leverandøren vår Kredittbanken har oppdatert og rett informasjon om deg. Det går kjapt å svara!',
        kredittbankenInfoText: '{} blir levert av Kredittbanken',
        taskType: {
            CONSUMER_LOAN: 'Forbrukslån',
            REFINANCE_LOAN: 'Refinansiering',
            CREDIT_LIMIT_INCREASE: 'Kredittkort',
            NEW_CARD: 'Kredittkort',
            SUPPLEMENTARY_CARD: 'Kredittkort',
        },
        completeTask: 'Fullfør søknad om {}',
        uploadDocuments: 'Send inn dokumentasjon',
        signDocuments: 'Søknad om {} er godkjend',
        taskManagerTaskType: {
            CONSUMER_LOAN: 'forbrukslån',
            REFINANCE_LOAN: 'refinansiering',
            CREDIT_LIMIT_INCREASE: 'kredittøkning',
            NEW_CARD: 'kredittkort',
            SUPPLEMENTARY_CARD: 'tilleggskort',
        },
    },
    kredittbankenTask: {
        NEW_CARD: {
            COMPLETE_INPUT: {
                title: 'Søknad om kredittkort',
                subTitle: 'Vil du halda fram på søknaden om kredittkort?',
                buttonText: 'Hald fram',
            },
            UPLOAD_DOCUMENTATION: {
                title: 'Send inn dokumentasjon',
                subTitle: 'Vi treng nokre dokument frå deg for å kunna gi deg eit tilbod om kredittkort',
                buttonText: 'Last opp dokumentasjon',
            },
            SIGN: {
                title: 'Søknad om kredittkort',
                subTitle: 'Du har fått tilbod om kredittkort',
                buttonText: 'Signér dokument',
            },
            CONFIRM: {
                title: '',
                subTitle: '',
                buttonText: '',
            },
        },
        REFINANCE_LOAN: {
            COMPLETE_INPUT: {
                title: 'Søknad om refinansiering',
                subTitle: 'Vil du halda fram på lånesøknaden for refinansiering?',
                buttonText: 'Hald fram',
            },
            UPLOAD_DOCUMENTATION: {
                title: 'Send inn dokumentasjon',
                subTitle: 'Vi treng nokre dokument frå deg for å kunna gi deg eit tilbod om refinansiering',
                buttonText: 'Last opp dokumentasjon',
            },
            SIGN: {
                title: 'Søknad om refinansiering',
                subTitle: 'Du har fått tilbod om refinansiering',
                buttonText: 'Signér lånedokument',
            },
            CONFIRM: {
                title: '',
                subTitle: '',
                buttonText: '',
            },
        },
        CONSUMER_LOAN: {
            COMPLETE_INPUT: {
                title: 'Søknad om forbrukslån',
                subTitle: 'Vil du halda fram på lånesøknaden for forbrukslån?',
                buttonText: 'Hald fram',
            },
            UPLOAD_DOCUMENTATION: {
                title: 'Send inn dokumentasjon',
                subTitle: 'Vi treng nokre dokument frå deg for å kunna gi deg eit tilbod om forbrukslån',
                buttonText: 'Last opp dokumentasjon',
            },
            SIGN: {
                title: 'Søknad om forbrukslån',
                subTitle: 'Du har fått tilbod om forbrukslån',
                buttonText: 'Signér lånedokument',
            },
            CONFIRM: {
                title: '',
                subTitle: '',
                buttonText: '',
            },
        },
        CREDIT_LIMIT_INCREASE: {
            COMPLETE_INPUT: {
                title: 'Søknad om kredittauke',
                subTitle: 'Vil du hald fram på søknaden om kredittøkning?',
                buttonText: 'Hald fram',
            },
            UPLOAD_DOCUMENTATION: {
                title: 'Send inn dokumentasjon',
                subTitle: 'Vi treng nokre dokument frå deg for å kunna gi deg kredittauke',
                buttonText: 'Last opp dokumentasjon',
            },
            SIGN: {
                title: '',
                subTitle: '',
                buttonText: '',
            },
            CONFIRM: {
                title: 'Søknad om kredittauke',
                subTitle: 'Søknad om kredittauke er godkjend',
                buttonText: 'Godkjenn kredittauke',
            },
        },
        SUPPLEMENTARY_CARD: {
            COMPLETE_INPUT: {
                title: 'Søknad om tilleggskort',
                subTitle: 'Vil du hald fram på søknaden om tilleggskort?',
                buttonText: 'Hald fram',
            },
            UPLOAD_DOCUMENTATION: {
                title: 'Send inn dokumentasjon',
                subTitle: 'Vi treng nokre dokument frå deg for å kunna gi deg eit tilbod om tilleggskort',
                buttonText: 'Last opp dokumentasjon',
            },
            SIGN: {
                title: 'Søknad om tilleggskort',
                subTitle: 'Tilleggskortet ditt er godkjent',
                buttonText: 'Signér dokument',
            },
            CONFIRM: {
                title: 'Søknad om tilleggskort',
                subTitle: 'Tilleggskortet ditt er godkjent',
                buttonText: 'Signér dokument',
            },
        },
    },
    loanApplications: {
        type: {
            HOUSE_LOAN_INCREASE: 'Søknad om økt bustadlån',
            PROOF_OF_FINANCING: 'Søknad om finansieringsbevis',
            NEW_LOAN: 'Søknad om nytt bustadlån på eksisterande bustad',
            MOVING: 'Søknad om flytting av bustadlån',
            HOUSE_LOAN: 'Søknad om bustadlån',
            UNKNOWN: '',
        },
        status: {
            ACTIVE: 'Søknad påbyrja',
            WAITING_FOR_CO_BORROWER: 'Ventar på medlåntakar',
            APPLICATION_BEING_PROCESSED: 'Behandlast',
            APPROVED: 'Nytt lånetilbod',
            BEING_PREPARED_FOR_PAYMENT: 'Klargjerast for utbetaling',
            PAID_OUT: 'Utbetalt',
            REFUSED: 'Avslått',
            CLOSED: 'Avslutta',
            EXPIRED: 'Utløpt',
            INFORMATION_BEING_PROCESSED: 'Opplysningar blir behandla',
            WAITING_FOR_YOUR_APPROVAL: 'Ventar på ditt samtykke',
            UNKNOWN: '',
        },
        needsAction: 'Krevar handling',
    },
    updateToSwitchLanguage: 'For å kunna velja språk må du oppdatera til siste versjon av mobilbanken',
    unknownAccountWarning: 'Dette er ein konto du ikkje eier, dobbeltsjekk om det er riktig kontonummer',
    unknownAccount: 'Ukjend konto',
    futurePaymentLimitWarning: 'Éin eller fleire av betalingane dine vil overskride beløpsgrensa. Du må endre betalinga, eller justere beløpsgrensa under innstillingar',
    goToTop: 'Gå til toppen',
    goBack: 'Gå tilbake',
    tasks: 'Oppgåver',
    otherTasks: 'Andre oppgåver',
    edit: 'Rediger',
    onlyOneAccount: 'Du har bare èin konto!',
    accountNeedsMultipleApproversTransactionInfoMessage: 'Denne kontoen krev flerpartsgodkjenning. Klikk deg inn på transaksjonane for å sjå kven som har betalt og godkjent.',
    more: 'Meir',
    moveAvtaleGiro: {
        whenYouStartTheProcess: 'Når du startar prosessen ved å logge deg inn med BankID, får du ein oversikt over aktive\n' +
            'AvtaleGiro-avtalar du har i andre bankar. Da kan du velje alle eller kun eit utvalg AvtaleGiro\n' +
            'som flyttast over til oss.',
        quickAndIntuitive: 'Det hele er kjapt og intuitivt, og du får gleda av å samle alt på eitt sted for en enklare bankkvardag!',
        notaBene: 'NB!',
        moveOn: 'Videre',
        startProcess: 'Start prosessen',
        chooseAvtaleGiros: 'Velg AvtaleGiro',
        notaBeneDescription: '{} Skulle du ha AvtaleGiro liggjande til forfall, blir desse også overført. Husk derfor å ha nok penger disponibelt på konto før du flyttar.',
        moveAvtaleGiro: 'Flytt AvtaleGiro ({})',
        newHome: 'Dette vil bli AvtaleGiroanes sitt nye heim',
        chooseAvtaleGiroPaymentAccount: 'AvtaleGiroens betalingskonto',
        avtaleGirosInOtherBanks: 'AvtaleGiro i andre banker',
        moveHasStarted: 'Flyttinga vart utført!',
        toAvtaleGiroPage: 'Til AvtaleGiro-sida',
        chooseAll: 'Vel alle',
        removeChosen: 'Fjern valde',
        confirmation: 'No er enda fleire AvtaleGiro samla på eitt sted',
        toFrontPage: 'Til framsida',
        backToTheFrontpage: 'Tilbake til framsida',
        ofChosen: '{} av {} valde',
        summary: 'Oppsummering',
        youAreReadyToMove: 'Du er klar til å flytte over {} til {}, {}.',
        moveAvtaleGirosNow: 'Flytt AvtaleGiro nå',
        foundNoAvtaleGiros: 'Vi fann ingen AvtaleGiro frå andre bankar',
        someAvtaleGirosMightHaveANewMaxAmount: 'Det kan hende du har fått ein ny maksgrense på avtalane dine. Dette kan du sjøl administrera på {}-sida.',
        errors: {
            debitAccountNotSelected: 'Du må velja ein konto å betale AvtaleGiroane med!',
            noAvtaleGirosSelected: 'Du må velja minst éin AvtaleGiro å flytte',
            couldNotFindExternalAvtaleGiros: 'Vi klarer ikkje hente inn AvtaleGiro fra andre banker akkurat nå. Vennligst prøv om att no eller litt seinare. Om problemet vedvarar, kontakt oss under Hjelp og kontakt i menyen.',
            couldNotMoveSomeOrAllAvtaleGiros: 'Vi klarte ikkje å flytte ein eller flere av AvtaleGiroane. Prøv om att med knappen under.',
            noValidAccounts: 'Vi fann ingen kontoar du kan betale AvtaleGiroane dine fra',
            ifThisIsWrongContactUs: 'Hvis dette er feil, kontakt oss under Hjelp og kontakt i menyen.',
            accountsCouldNotBeFetched: 'Vi klarte ikkje å laste inn kontoane dine',
        },
        rejected: {
            heading: 'Signeringen med BankID gjekk ikkje igjennom',
            description: 'Prøv om att ved å trykkje på knappen under. Viss problemet held fram, ta kontakt med oss',
        },
    },
    accountIsBlocked: 'Kontoen er blokkert',
    messages: {
        oldMessagesWillBeRemoved: 'Frå og med 15. januar blir alle de gamle meldingane dine borte',
        ifYouWishToSaveThem: 'Viss du ynskjer å lagre nokon av meldingane dine, ver venleg og gjer det i {} før 15. januar.',
        messagesText: 'Meldingar',
    },
    psd2Warning: 'Du har valt ein betalingsmåte som berre brukerstaden, gjennom sin betalingsleverandør, kan gjere endringar på. Du må derfor kontakte brukerstaden for vidare hjelp',
    approveMultipleEFaktura: {
        approveEFaktura: 'Godkjenn eFaktura',
        toTheFrontpage: 'Til framsida',
        seeEFaktura: 'Sjå gjenverande eFaktura',
        eFakturasWaiting: '{} eFaktura ventar',
        approveAndPayNEFaktura: 'Godkjenn og betal ({})',
        subtotal: 'Til saman {}',
        doYouWantToApproveAll: 'Vil du godkjenne alle?',
        youAreApprovingNEFakturasAtOnce: 'Du betaler {} eFaktura på éin gong, totalt {}',
        youAreApprovingNEFakturasWithSharedAtOnce: 'Du betaler {} eFaktura på éin gong, kor {} av dei er ein delt eFaktura, totalt {}',
        choosePaymentAccount: 'Vel betalingskonto',
        allEFakturasArePaidFromThisAccount: 'Alle eFakturaene betalast frå denne kontoen',
        doYouWishToPayFromDifferentAccounts: 'Ynskjer du ulike kontoer for kvar eFaktura, må du godkjenne enkeltvis',
        approveNow: 'Godkjenn nå',
        error: {
            chooseDebitAccount: 'Du må velje ein betalingskonto',
            noCoverage: 'Det er ikkje nok pengar på konto',
            exceedsMaximumAmount: 'Maksgrense for ei betaling er {} kr per betaling',
            exceedsMonthlyMaximumAmount: 'Det totale beløpet vil gå over månadleg betalingsgrense på {} kr',
        },
        signingResult: {
            error: {
                nEFakturaWasNotApproved: '{} av eFakturaene vart ikkje godkjent',
                looksLikeWeCouldNotApproveAllYourEFaktura: 'Det ser ut som vi ikkje klarte å godkjenne alle eFakturaene. Gjer eventuelle endringar og forsøk igjen nå, eller prøv om att seinare.',
            },
            success: {
                allEFakturasWasApproved: 'Alle eFakturaene vart godkjent!',
                eFakturasArePaidOnDueDate: 'Merk at dei betalast på betalingsdato definert i dei enkelte eFakturaene. Har ein eFaktura forfalt? Da setjast betalingsdatoen til i dag eller næraste bankverkedag.',
            },
        },
    },
    commonErrors: {
        gettingAccountsFailed: 'Henting av konto feila',
        tryLoadingAgain: 'Prøv å laste om att. Om problemet held fram, vent eit par timer, eller kontakt oss. Koden under kan forklare oss kva som er gale.',
        copyRCID: 'Kopier feilkode',
        paymentAndNextSalaryFailed: 'Neste lønn feila',
        paymentFailed: 'Betalinga feila',
        thereIsAnErrorOnOurSide: 'Det ser dessverre ut som noe er fel på vår side. Ver venleg og forsøk om att litt seinare. Våre teknikare er på saka!',
    },
    downloadNudge: {
        downloadMobilBank: 'Last ned mobilbanken!',
        getABetterOverview: 'Få ein betre bankoppleving med appen vår',
    },
    enablePushModal: {
        title: 'Vil du ha endå betre kontroll?',
        paragraph1: 'Hald deg oppdatert på økonomien din, utan å logga inn. Få beskjed når ei rekning nærmar seg forfall, når du får ein ny eFaktura, eller best av alt – når lønna har landa på konto.',
        paragraph2: 'Slå på standard utval her, så kan du leggja til lønnsvarsel og dessutan justera enkeltvarsel under Pushvarslinger.',
        toggle: 'Eg vil ha push',
        pushNotificationLink: 'Til Pushvarslingar',
        doneButton: 'Ferdig',
        closeButton: 'Kanskje seinare',
    },
    appearance: {
        visualThemeHeader: 'Visuelt tema',
        visualThemeDescription: 'Få tema som markerar særskilde hendingar',
    },
    holdingAccount: {
        label: 'Fondskonto',
        unrealizedGains: {
            positive: 'Verdiauke',
            negative: 'Verditap',
            noChange: 'Inga verdiendring',
        },
    },
};
export default nnTranslations;
//# sourceMappingURL=data:application/json;base64,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